function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var ModTemplate = require('../../lib/templates/modtemplate');
var SaitoHeader = require('../../lib/saito/ui/saito-header/saito-header');
var SaitoOverlay = require('../../lib/saito/ui/saito-overlay/saito-overlay');
var Transaction = require('../../lib/saito/transaction')["default"];
var JSON = require('json-bigint');
var path = require('path');
var HomePage = require('./index');
var StackMain = require('./lib/ui/main');
var ExploreOverlay = require('./lib/ui/overlay/explore');
var CreatePost = require('./lib/ui/create-post');
var ViewPost = require('./lib/ui/view-post');
var _require = require('./lib/access/access-scripts'),
  getAccessScriptForIntent = _require.getAccessScriptForIntent,
  embedWitnessInScript = _require.embedWitnessInScript;

//
// Stack - Permissioned Blogging Platform
//
// An open-source alternative to Substack that allows creators to publish
// subscription-based content on the Saito network. Supports:
// - Free and paid subscriptions
// - Permissioned content access
// - Creator monetization
// - Subscriber management
//
var Stack = /*#__PURE__*/function (_ModTemplate) {
  function Stack(app) {
    var _this;
    _classCallCheck(this, Stack);
    _this = _callSuper(this, Stack, [app]);
    _this.app = app;
    _this.name = 'Stack';
    _this.slug = 'stack';
    _this.description = 'Permissioned blogging platform - an open-source alternative to Substack';
    _this.categories = 'Social Media Blogging Publishing';
    _this.status = 'prod';
    _this["class"] = 'app';
    _this.icon_fa = 'fa-solid fa-newspaper';
    _this.shortlinks_enabled = 1;
    _this.pending_post_sig = null;
    _this.pending_post_pk = null;
    _this.pending_post_loaded = null;
    _this.social = _this.buildSocial({
      twitter: '@SaitoOfficial',
      title: 'Stack - Permissioned Blogging',
      url: '/stack',
      description: 'Open-source subscription-based blogging platform',
      image: 'https://saito.tech/wp-content/uploads/2022/04/saito_card.png'
    });

    // Cache for posts and subscriptions
    _this.postsCache = {
      byAuthor: new Map(),
      bySubscription: new Map(),
      allPosts: [],
      lastFetch: 0
    };

    // Transaction loading middleware
    // Track peers offering Stack service
    _this.peers = {};
    // In-memory cache for fetched transactions, keyed by signature
    _this.transactionCache = {};

    // In-memory draft state (single source of truth)
    // Ordered by last-modified DESC (most recent first)
    _this.drafts = [];

    // ========================================================================
    // INVARIANT 1: SYSTEM IDENTITY - Canonical identity constants
    // ========================================================================
    // "Saito Official" is a hardcoded system identity that must never be inferred
    // All references to "Saito Official" must use this constant
    // TODO: Replace with actual Saito Official public key when available
    _this.STACK_OFFICIAL_PUBLICKEY = 'k73CaRGwgNbqq1prNngSstb9NrfkaJVQwq8onf1oabBz';
    _this.overlay = new SaitoOverlay(app, _this);
    _this.exploreOverlay = new ExploreOverlay(app, _this);
    _this.main = new StackMain(app, _this, '.saito-container');
    _this.create_post_ui = new CreatePost(app, _this, '.saito-container');
    _this.chooseDraftOverlay = null; // Lazy-loaded when needed
    _this.header = null;

    // Callback for after post creation
    _this.callbackAfterPost = null;
    _this.styles = ['/saito/saito.css', '/stack/style.css'];
    _this.scripts = [];
    return _this;
  }

  ////////////////////////////
  // Initialization        //
  ////////////////////////////
  _inherits(Stack, _ModTemplate);
  return _createClass(Stack, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        var SaitoTransactionMonitor;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _superPropGet(Stack, "initialize", this, 3)([app]);
            case 1:
              if (this.app.BROWSER) {
                SaitoTransactionMonitor = require('../../lib/saito/ui/saito-transaction-monitor/saito-transaction-monitor');
                this.transaction_monitor = new SaitoTransactionMonitor(this.app, this);
              }

              // Load persistent local UX state
              this.load();

              // Server: prime transactionCache and postsCache so we can serve posts with initial HTML
              if (!this.app.BROWSER) {
                this.prefetchStackCache()["catch"](function (err) {
                  console.debug('Stack: prefetchStackCache failed', err);
                });
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
    /**
     * Ask Profile (if installed) to set or clear the preferred Stack URL.
     * Blank address removes the Profile `stack` field. No-op when Profile is absent.
     */
  }, {
    key: "updateProfile",
    value: function () {
      var _updateProfile = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var address,
          api,
          stack,
          _args2 = arguments;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              address = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : '';
              if (this.app.BROWSER) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              api = this.app.modules.returnFirstRespondTo('profile-update');
              if (!(!api || typeof api.update !== 'function')) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              stack = address == null ? '' : String(address).trim();
              _context2.n = 3;
              return api.update({
                stack: stack
              });
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function updateProfile() {
        return _updateProfile.apply(this, arguments);
      }
      return updateProfile;
    }()
    /**
     * Current Profile `stack` field via optional profile-update capability.
     */
  }, {
    key: "returnProfileStackUrl",
    value: function returnProfileStackUrl() {
      var _this$app$modules$ret, _this$app$modules;
      var api = (_this$app$modules$ret = (_this$app$modules = this.app.modules).returnFirstRespondTo) === null || _this$app$modules$ret === void 0 ? void 0 : _this$app$modules$ret.call(_this$app$modules, 'profile-update');
      if (!api || typeof api.get !== 'function') {
        return '';
      }
      try {
        var profile = api.get() || {};
        return String(profile.stack || '').trim();
      } catch (err) {
        return '';
      }
    }

    /**
     * Path for a creator Stack feed: /stack/<publickey>
     */
  }, {
    key: "returnStackPath",
    value: function returnStackPath() {
      var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var key = String(publicKey || '').trim();
      if (!key) {
        return '/' + encodeURI(this.returnSlug());
      }
      return "/".concat(encodeURI(this.returnSlug()), "/").concat(encodeURIComponent(key));
    }

    /**
     * Absolute shareable URL for a creator Stack feed.
     */
  }, {
    key: "returnStackUrl",
    value: function returnStackUrl() {
      var _window$location;
      var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var path = this.returnStackPath(publicKey);
      if (this.app.BROWSER && typeof window !== 'undefined' && (_window$location = window.location) !== null && _window$location !== void 0 && _window$location.origin) {
        return "".concat(window.location.origin).concat(path);
      }
      return path;
    }
  }, {
    key: "shouldAffixCallbackToModule",
    value: function shouldAffixCallbackToModule(modname) {
      var _this$transaction_mon;
      var tx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (modname === this.name) {
        return 1;
      }
      // Allow the shared transaction monitor to receive NFT mint confirmations.
      if ((_this$transaction_mon = this.transaction_monitor) !== null && _this$transaction_mon !== void 0 && _this$transaction_mon.tx && tx !== null && tx !== void 0 && tx.signature && tx.signature === this.transaction_monitor.tx.signature) {
        return 1;
      }
      return 0;
    }

    /**
     * Server-only: fetch last 5 Saito Official posts and last 5 other recent public Stack posts
     * into transactionCache and postsCache so GET /stack/:pk/:txsig can serve them with the page.
     */
  }, {
    key: "prefetchStackCache",
    value: function () {
      var _prefetchStackCache = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this2 = this;
        var officialKey, limit, officialTxs, toCache, _iterator, _step, tx, allRecent, otherTxs, _iterator2, _step2, _tx, _t, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              officialKey = this.STACK_OFFICIAL_PUBLICKEY;
              limit = 5; // 1. Last 5 posts from Saito Official
              _context3.p = 1;
              _context3.n = 2;
              return this.loadPostsForAuthor(officialKey, {
                forceRemote: true
              });
            case 2:
              officialTxs = _context3.v;
              toCache = (officialTxs || []).slice(0, limit);
              _iterator = _createForOfIteratorHelper(toCache);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  tx = _step.value;
                  if (tx && tx.signature) {
                    this.receiveStackPostTransaction(tx, null);
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t = _context3.v;
              console.debug('Stack: prefetch official posts failed', _t);
            case 4:
              _context3.p = 4;
              _context3.n = 5;
              return new Promise(function (resolve) {
                _this2.app.storage.loadTransactions({
                  field1: 'Stack',
                  field4: 'stack:post',
                  updated_later_than: 0,
                  limit: 50
                }, function (txs) {
                  return resolve(txs || []);
                }, 'localhost');
              });
            case 5:
              allRecent = _context3.v;
              otherTxs = (allRecent || []).filter(function (tx) {
                var _tx$from;
                return (tx === null || tx === void 0 || (_tx$from = tx.from) === null || _tx$from === void 0 || (_tx$from = _tx$from[0]) === null || _tx$from === void 0 ? void 0 : _tx$from.publicKey) && tx.from[0].publicKey !== officialKey;
              }).sort(function (a, b) {
                var _a$optional, _b$optional;
                var ta = a.timestamp || ((_a$optional = a.optional) === null || _a$optional === void 0 ? void 0 : _a$optional.updated_at) || 0;
                var tb = b.timestamp || ((_b$optional = b.optional) === null || _b$optional === void 0 ? void 0 : _b$optional.updated_at) || 0;
                return tb - ta;
              }).slice(0, limit);
              _iterator2 = _createForOfIteratorHelper(otherTxs);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  _tx = _step2.value;
                  if (_tx && _tx.signature) {
                    this.receiveStackPostTransaction(_tx, null);
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              _context3.n = 7;
              break;
            case 6:
              _context3.p = 6;
              _t2 = _context3.v;
              console.debug('Stack: prefetch other recent posts failed', _t2);
            case 7:
              return _context3.a(2);
          }
        }, _callee3, this, [[4, 6], [1, 3]]);
      }));
      function prefetchStackCache() {
        return _prefetchStackCache.apply(this, arguments);
      }
      return prefetchStackCache;
    }() ////////////////////////////
    // Rendering             //
    ////////////////////////////
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(app) {
        var _this3 = this;
        var pathname, slug, pathAfterSlug, segments, publicKey, _publicKey, transactionSignature;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (this.browser_active) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              this.header = new SaitoHeader(this.app, this);
              _context5.n = 2;
              return this.header.initialize(this.app);
            case 2:
              this.addComponent(this.header);
              _context5.n = 3;
              return _superPropGet(Stack, "render", this, 3)([this.app, this]);
            case 3:
              // Discover local drafts (non-blocking, in-memory state)
              this.discoverDrafts()["catch"](function (err) {
                console.error('Stack: Error discovering drafts:', err);
              });

              // ========================================================================
              // URL ROUTING: Parse pathname and route to appropriate view
              // ========================================================================
              pathname = window.location.pathname;
              slug = '/' + this.slug;
              if (!(pathname === slug && new URLSearchParams(window.location.search).get('publish') === '1')) {
                _context5.n = 5;
                break;
              }
              window.history.replaceState({}, '', slug);
              _context5.n = 4;
              return this.main.handleStartWriting();
            case 4:
              return _context5.a(2);
            case 5:
              if (!pathname.startsWith(slug)) {
                _context5.n = 9;
                break;
              }
              // Extract path segments after /stack
              pathAfterSlug = pathname.substring(slug.length);
              segments = pathAfterSlug.split('/').filter(function (seg) {
                return seg.length > 0;
              });
              if (!(segments.length === 1)) {
                _context5.n = 6;
                break;
              }
              // /stack/<publicKey> - Show creator's posts in Explorer
              publicKey = segments[0];
              this.main.render();
              setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
                return _regenerator().w(function (_context4) {
                  while (1) switch (_context4.n) {
                    case 0:
                      _context4.n = 1;
                      return _this3.handleCreatorView(publicKey);
                    case 1:
                      return _context4.a(2);
                  }
                }, _callee4);
              })), 0);
              return _context5.a(2);
            case 6:
              if (!(segments.length === 2)) {
                _context5.n = 8;
                break;
              }
              // /stack/<publicKey>/<transactionSignature> - Show specific blog post
              _publicKey = segments[0];
              transactionSignature = segments[1];
              _context5.n = 7;
              return this.handlePostView(_publicKey, transactionSignature);
            case 7:
              return _context5.a(2);
            case 8:
              if (!(segments.length > 2)) {
                _context5.n = 9;
                break;
              }
              // Invalid URL - too many segments
              this.handleInvalidURL();
              return _context5.a(2);
            case 9:
              // Default: Render the main component (splash page)
              this.main.render();
            case 10:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function render(_x2) {
        return _render.apply(this, arguments);
      }
      return render;
    }() ////////////////////////////
    // URL Routing Handlers  //
    ////////////////////////////
    /**
     * Handle creator view: /stack/<publicKey>
     * Shows Explorer overlay with posts from that creator
     */
  }, {
    key: "handleCreatorView",
    value: function () {
      var _handleCreatorView = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(publicKey) {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (publicKey) {
                _context6.n = 1;
                break;
              }
              this.handleInvalidURL();
              return _context6.a(2);
            case 1:
              // Initialize ExploreOverlay if needed
              if (!this.exploreOverlay) {
                this.exploreOverlay = new ExploreOverlay(this.app, this);
              }

              // Show overlay immediately with loading state
              this.exploreOverlay.isLoading = true;
              this.exploreOverlay.posts = {};
              this.exploreOverlay.targetPublicKey = publicKey;
              this.exploreOverlay.render();
            case 2:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function handleCreatorView(_x3) {
        return _handleCreatorView.apply(this, arguments);
      }
      return handleCreatorView;
    }()
    /**
     * Handle blog post view: /stack/<publicKey>/<transactionSignature>
     * Shows ViewPost for the specific transaction
     */
  }, {
    key: "handlePostView",
    value: function () {
      var _handlePostView = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var publicKey,
          transactionSignature,
          container,
          tx,
          _tx2,
          _args7 = arguments,
          _t3,
          _t4;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              publicKey = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : '';
              transactionSignature = _args7.length > 1 ? _args7[1] : undefined;
              if (transactionSignature) {
                _context7.n = 1;
                break;
              }
              this.handleInvalidURL();
              return _context7.a(2);
            case 1:
              // Initialize ViewPost if needed (cache for reuse)
              if (!this.viewPostComponent) {
                this.viewPostComponent = new ViewPost(this.app, this, '.saito-container');
              }
              container = document.querySelector('.saito-container'); // Use post embedded in initial HTML when server had it in cache (avoids archive request)
              if (!(typeof window.__STACK_INITIAL_POST === 'string' && window.__STACK_INITIAL_POST.length > 0)) {
                _context7.n = 6;
                break;
              }
              _context7.p = 2;
              tx = new Transaction();
              tx.deserialize_from_web(this.app, window.__STACK_INITIAL_POST);
              window.__STACK_INITIAL_POST = null;
              if (!(tx.signature === transactionSignature)) {
                _context7.n = 3;
                break;
              }
              this.transactionCache[transactionSignature] = tx;
              this.viewPostComponent.render(tx);
              this.pending_post_loaded = true;
              return _context7.a(2);
            case 3:
              _context7.n = 5;
              break;
            case 4:
              _context7.p = 4;
              _t3 = _context7.v;
              console.debug('Stack: Failed to use embedded initial post', _t3);
            case 5:
              window.__STACK_INITIAL_POST = null;
            case 6:
              // Show loading state
              if (container) {
                container.innerHTML = "\n        <div class=\"stack-status\">\n          <i class=\"fa-solid fa-spinner fa-spin\"></i>\n          <p>Loading blog post for you\u2026</p>\n        </div>\n      ";
              }

              // Load the transaction by signature
              _context7.p = 7;
              _context7.n = 8;
              return this.loadPost(transactionSignature, {}, null);
            case 8:
              _tx2 = _context7.v;
              if (_tx2) {
                _context7.n = 9;
                break;
              }
              if (container) {
                if (this.pending_post_sig != '' && this.pending_post_loaded != true) {
                  container.innerHTML = "\n    <div class=\"stack-status network\">\n      <div class=\"saito-spinner\"></div>\n      <div class=\"message\">Loading Post from Saito Network</div>\n    </div>\n  ";
                } else {
                  container.innerHTML = "\n            <div class=\"stack-status\">\n              <i class=\"fa-solid fa-exclamation-triangle\"></i>\n              <h3>Unable to load this blog post</h3>\n              <p>\n                The blog post you're looking for could not be found. It may have been deleted, or you may not have permission to view it.\n              </p>\n            </div>\n            ";
                }
              }
              return _context7.a(2);
            case 9:
              // Render the post
              this.viewPostComponent.render(_tx2);
              this.pending_post_loaded = true;
              _context7.n = 11;
              break;
            case 10:
              _context7.p = 10;
              _t4 = _context7.v;
              console.error('Stack: Error loading blog post:', _t4);
              // Show error state
              if (container) {
                container.innerHTML = "\n          <div class=\"stack-status\">\n            <i class=\"fa-solid fa-exclamation-triangle\"></i>\n            <h3>Unable to load this blog post</h3>\n            <p>\n              An error occurred while loading the blog post. Please try again later.\n            </p>\n          </div>\n        ";
              }
            case 11:
              return _context7.a(2);
          }
        }, _callee7, this, [[7, 10], [2, 4]]);
      }));
      function handlePostView() {
        return _handlePostView.apply(this, arguments);
      }
      return handlePostView;
    }()
    /**
     * Handle invalid URL - show error state
     */
  }, {
    key: "handleInvalidURL",
    value: function handleInvalidURL() {
      var container = document.querySelector('.saito-container');
      if (container) {
        container.innerHTML = "\n        <div class=\"stack-status\">\n          <i class=\"fa-solid fa-exclamation-triangle\"></i>\n          <h3>Invalid URL</h3>\n          <p>\n            The URL you requested is not valid. Please check the URL and try again.\n          </p>\n        </div>\n      ";
      }
    }
  }, {
    key: "toggleSubscriptionsSidebar",
    value: function toggleSubscriptionsSidebar() {
      // Placeholder - will implement sidebar later
      console.log('Toggle subscriptions sidebar (placeholder)');
    }
  }, {
    key: "showExplorePostsOverlay",
    value: function showExplorePostsOverlay() {
      // Placeholder - will implement overlay later
      console.log('Show explore posts overlay (placeholder)');
    }

    ////////////////////////////
    // Service Declaration    //
    ////////////////////////////
    /**
     * Declares Stack service to peers, following RedSquare pattern.
     * Allows peers to advertise Stack capability.
     */
  }, {
    key: "returnServices",
    value: function returnServices() {
      var services = [];
      if (!this.app.BROWSER || this.offerService) {
        services.push(this.app.network.createPeerService(null, 'stack', 'Stack Post Archive'));
      }
      return services;
    }

    ////////////////////////////
    // Peer Management       //
    ////////////////////////////
    /**
     * Called when a peer connects with Stack service capability.
     * Tracks peers that advertise Stack service for future use.
     *
     * @param {Object} app - Saito application instance
     * @param {Object} peer - Peer object
     * @param {Object} service - Service object with service name
     */
  }, {
    key: "onPeerServiceUp",
    value: function () {
      var _onPeerServiceUp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(app, peer) {
        var service,
          peerKey,
          sig,
          pk,
          explore,
          _args8 = arguments;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              service = _args8.length > 2 && _args8[2] !== undefined ? _args8[2] : {};
              if (service.service === 'stack' || service.service === 'archive') {
                peerKey = (peer === null || peer === void 0 ? void 0 : peer.publicKey) || 'unknown';
                this.peers[peerKey] = {
                  peer: peer,
                  publicKey: peerKey,
                  connected: true
                };
              }

              //
              // Archives
              //
              if (!(service.service === 'archive' && this.browser_active && this.app.BROWSER)) {
                _context8.n = 3;
                break;
              }
              if (!this.pending_post_sig) {
                _context8.n = 2;
                break;
              }
              sig = this.pending_post_sig;
              pk = this.pending_post_pk;
              _context8.n = 1;
              return this.handlePostView(pk, sig);
            case 1:
              this.pending_post_sig = '';
              this.pending_post_pk = '';
            case 2:
              explore = this.exploreOverlay;
              if (!(explore !== null && explore !== void 0 && explore.awaitingPeers && explore.targetPublicKey && document.querySelector('#stack-explore-posts-grid'))) {
                _context8.n = 3;
                break;
              }
              _context8.n = 3;
              return explore.loadPostsForFilter(explore.targetPublicKey);
            case 3:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function onPeerServiceUp(_x4, _x5) {
        return _onPeerServiceUp.apply(this, arguments);
      }
      return onPeerServiceUp;
    }() ////////////////////////////
    // Inter-module Communication //
    ////////////////////////////
  }, {
    key: "respondTo",
    value: function respondTo() {
      var _this4 = this;
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var obj = arguments.length > 1 ? arguments[1] : undefined;
      if (type === 'redsquare-profile') {
        var _obj$profile;
        var publicKey = String((obj === null || obj === void 0 ? void 0 : obj.publicKey) || '').trim();
        if (!publicKey) {
          return null;
        }
        var link = String((obj === null || obj === void 0 || (_obj$profile = obj.profile) === null || _obj$profile === void 0 ? void 0 : _obj$profile.stack) || '').trim();
        if (!link) {
          var _this$app$modules$ret2, _this$app$modules2;
          var api = (_this$app$modules$ret2 = (_this$app$modules2 = this.app.modules).returnFirstRespondTo) === null || _this$app$modules$ret2 === void 0 ? void 0 : _this$app$modules$ret2.call(_this$app$modules2, 'profile-update');
          if (api && typeof api.get === 'function') {
            try {
              var profile = api.get(publicKey) || {};
              link = String(profile.stack || '').trim();
            } catch (err) {
              link = '';
            }
          }
        }
        if (!link) {
          return null;
        }
        return {
          text: 'Stack',
          link: link
        };
      }
      if (type === 'redsquare-create') {
        return {
          id: 'stack-publish',
          label: 'Publish',
          image: '/saito/icons/saito-stack-icon-solid.svg',
          callback: function callback() {
            if (typeof navigateWindow === 'function') {
              navigateWindow('/stack?publish=1');
            }
          }
        };
      }
      if (type === 'saito-header') {
        var x = [];
        if (!this.browser_active) {
          x.push({
            text: 'Stack',
            icon: this.icon_fa,
            rank: 100,
            type: 'navigation',
            callback: function callback(app, id) {
              navigateWindow('/stack');
            }
          });
        }
        return x;
      }
      if (type === 'user-menu') {
        return {
          text: "View Stack",
          icon: this.icon_fa,
          image: '/saito/icons/saito-stack-icon-solid.svg',
          callback: function callback(app, publicKey) {
            navigateWindow("/stack/".concat(publicKey));
          }
        };
      }
      if (type === 'saito-create-nft') {
        var this_mod = this;
        return {
          title: 'Stack Access NFT',
          "class": ['stack'],
          // This becomes the nft_type parameter for createMintNFTTransaction
          text: 'Stack Access Key',
          createData: function () {
            var _createData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(modfile) {
              return _regenerator().w(function (_context9) {
                while (1) switch (_context9.n) {
                  case 0:
                    return _context9.a(2, {
                      module: 'Stack',
                      duration: 300000
                    });
                }
              }, _callee9);
            }));
            function createData(_x6) {
              return _createData.apply(this, arguments);
            }
            return createData;
          }()
        };
      }
      if (type === 'saito-nft-transfer') {
        var _this_mod = this;
        return {
          "class": ['stack'],
          onTransfer: function () {
            var _onTransfer = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
              var nft,
                tx,
                receiver,
                data,
                duration,
                binding_hash,
                _canonical_string,
                digest,
                _privatekey,
                value_obj,
                my_publickey,
                last_inbound,
                i,
                value_json,
                value_b64,
                canonical_string,
                hash_digest,
                privatekey,
                sig,
                _args0 = arguments;
              return _regenerator().w(function (_context0) {
                while (1) switch (_context0.n) {
                  case 0:
                    nft = _args0.length > 0 && _args0[0] !== undefined ? _args0[0] : null;
                    tx = _args0.length > 1 && _args0[1] !== undefined ? _args0[1] : null;
                    receiver = _args0.length > 2 && _args0[2] !== undefined ? _args0[2] : '';
                    data = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                    console.log('***');
                    console.log('***');
                    console.log('***');
                    console.log('***');
                    console.log('***');
                    console.log('***');
                    console.log('adding routing path to Stack NFT...');
                    if (!tx.msg) {
                      tx.msg = {};
                    }
                    if (!tx.msg.data) {
                      tx.msg.data = {};
                    }
                    if (!Array.isArray(tx.msg.data.path)) {
                      tx.msg.data.path = [];
                    }
                    if (nft !== null && nft !== void 0 && nft.id) {
                      _context0.n = 1;
                      break;
                    }
                    return _context0.a(2, tx);
                  case 1:
                    if (!(nft != null && tx.msg.data.path.length == 0)) {
                      _context0.n = 3;
                      break;
                    }
                    if (!(nft.returnCreator() == _this4.publicKey)) {
                      _context0.n = 3;
                      break;
                    }
                    if (!(tx.msg.data.duration && !tx.msg.data.duration_sig)) {
                      _context0.n = 3;
                      break;
                    }
                    duration = tx.msg.data.duration;
                    binding_hash = nft.id;
                    _canonical_string = "".concat(duration, "|").concat(binding_hash);
                    digest = _this4.app.crypto.hash(_canonical_string);
                    _context0.n = 2;
                    return _this4.app.wallet.getPrivateKey();
                  case 2:
                    _privatekey = _context0.v;
                    console.log('SIGNING DURATION SIG FOR: ' + digest);
                    console.log('SIGNING DURATION SIG W/ BH: ' + binding_hash);
                    tx.msg.data.duration_sig = _this4.app.crypto.signMessage(digest, _privatekey);
                  case 3:
                    value_obj = {
                      timestamp: Date.now(),
                      delegate: false
                    };
                    if (data.delegate == true) {
                      value_obj.delegate = true;
                    }

                    //
                    // we want to extend the routing path from the point where *we*
                    // most recently acquired authority over the NFT, not from the
                    // end of the existing routing path. This prevents merchants who
                    // repeatedly sell inventory from accumulating customer history
                    // into future transfers, etc.
                    //
                    _context0.n = 4;
                    return _this_mod.app.wallet.getPublicKey();
                  case 4:
                    my_publickey = _context0.v;
                    if (Array.isArray(tx.msg.data.path) && tx.msg.data.path.length > 0) {
                      last_inbound = -1;
                      for (i = 0; i < tx.msg.data.path.length; i++) {
                        if (tx.msg.data.path[i].to === my_publickey) {
                          last_inbound = i;
                        }
                      }
                      if (last_inbound >= 0) {
                        tx.msg.data.path = tx.msg.data.path.slice(0, last_inbound + 1);
                      }
                    }
                    value_json = JSON.stringify(value_obj);
                    value_b64 = Buffer.from(value_json).toString('base64');
                    canonical_string = "".concat(receiver, "|").concat(value_b64, "|").concat(nft.id);
                    hash_digest = _this_mod.app.crypto.hash(canonical_string);
                    _context0.n = 5;
                    return _this_mod.app.wallet.getPrivateKey();
                  case 5:
                    privatekey = _context0.v;
                    sig = _this_mod.app.crypto.signMessage(hash_digest, privatekey);
                    tx.msg.data.path.push({
                      to: receiver,
                      value: value_b64,
                      sig: sig
                    });
                    return _context0.a(2, tx);
                }
              }, _callee0);
            }));
            function onTransfer() {
              return _onTransfer.apply(this, arguments);
            }
            return onTransfer;
          }()
        };
      }
      if (type == 'saito-return-key') {
        return {
          returnKey: function returnKey() {
            var _data;
            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            //
            // data might be a publickey, permit flexibility
            // in how this is called by pushing it into a
            // suitable object for searching
            //
            if (typeof data === 'string') {
              var d = {
                publicKey: ''
              };
              d.publicKey = data;
              data = d;
            }
            if (((_data = data) === null || _data === void 0 ? void 0 : _data.publicKey) == _this4.STACK_OFFICIAL_PUBLICKEY) {
              return {
                publicKey: data.publicKey,
                identifier: 'SaitoOfficial'
              };
            }
            return null;
          },
          returnKeys: function returnKeys() {
            return [{
              publicKey: _this4.STACK_OFFICIAL_PUBLICKEY,
              identifier: 'SaitoOfficial'
            }];
          }
        };
      }
      return _superPropGet(Stack, "respondTo", this, 3)([type, obj]);
    }

    ////////////////////////////
    // Transaction Handling  //
    ////////////////////////////
  }, {
    key: "onConfirmation",
    value: function () {
      var _onConfirmation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(blk, tx, conf) {
        var txmsg;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              txmsg = tx.returnMessage(); // Check if transaction is relevant to Stack module
              if (!(txmsg.module !== this.name)) {
                _context1.n = 1;
                break;
              }
              return _context1.a(2);
            case 1:
              if (!(Number(conf) == 0)) {
                _context1.n = 4;
                break;
              }
              if (!(txmsg.request === 'create stack post request')) {
                _context1.n = 4;
                break;
              }
              console.log('Stack onConfirmation: createStackPost');

              // Archive management - SINGLE place managing Stack archive writes
              _context1.n = 2;
              return this.onReceiveBlogPost(tx, blk);
            case 2:
              _context1.n = 3;
              return this.receiveStackPostTransaction(tx, blk);
            case 3:
              if (!tx.isFrom(this.publicKey)) {
                _context1.n = 4;
                break;
              }
              _context1.n = 4;
              return this.cleanupPendingDrafts();
            case 4:
              return _context1.a(2);
          }
        }, _callee1, this);
      }));
      function onConfirmation(_x7, _x8, _x9) {
        return _onConfirmation.apply(this, arguments);
      }
      return onConfirmation;
    }() ////////////////////////////
    // Access Script Pipeline
    ////////////////////////////
    /**
     * Get access script for a publish intent
     *
     * Maps a normalized publish intent to a canonical access script template.
     * Returns null for public posts (no access gate).
     *
     * @param {Object} intent - Publish intent object
     * @param {string} intent.visibility - "public" | "private"
     * @param {string|null} intent.access_mode - null | "transferable" | "non-transferable"
     * @param {Object|null} intent.time_limit - null | { seconds: number }
     * @param {string} intent.author - Public key of the post author
     * @returns {Object|null} Access script object, or null for public posts
     */
  }, {
    key: "getAccessScriptForPublishIntent",
    value: function getAccessScriptForPublishIntent(intent) {
      try {
        return getAccessScriptForIntent(intent);
      } catch (error) {
        console.error('Stack: Error getting access script for intent:', error);
        throw error;
      }
    }
  }, {
    key: "buildUnlockAccessScript",
    value: function buildUnlockAccessScript(publishIntent, witnessData) {
      var lockingScript = this.getAccessScriptForPublishIntent(publishIntent);
      if (lockingScript === null) {
        throw new Error('buildUnlockAccessScript: public posts have no unlock script');
      }
      var witnessByOpcode = {};
      if (witnessData !== null && witnessData !== void 0 && witnessData.utxokey1 && witnessData !== null && witnessData !== void 0 && witnessData.utxokey2 && witnessData !== null && witnessData !== void 0 && witnessData.utxokey3) {
        witnessByOpcode.CHECKOWNNFTWHERE = {
          utxokey1: witnessData.utxokey1,
          utxokey2: witnessData.utxokey2,
          utxokey3: witnessData.utxokey3
        };
      }
      if (Array.isArray(witnessData === null || witnessData === void 0 ? void 0 : witnessData.hops) && witnessData.hops.length > 0) {
        witnessByOpcode.CHECKPATHHOP = {
          hops: witnessData.hops
        };
      }
      if ((witnessData === null || witnessData === void 0 ? void 0 : witnessData.duration) != null && witnessData !== null && witnessData !== void 0 && witnessData.duration_sig) {
        witnessByOpcode.IMPORTFIELD = {
          duration: witnessData.duration,
          signature: witnessData.duration_sig
        };
      }
      var completeScript = embedWitnessInScript(lockingScript, witnessByOpcode);
      return JSON.stringify(completeScript);
    }

    /**
     * Hash an access script using app.core.scripting.hash()
     *
     * Hashes the witness-free locking script JSON. Same script object will
     * always produce the same hash via Rust canonicalization.
     *
     * @param {Object|null} script - Access script object, or null
     * @returns {string} Access hash (empty string if script is null)
     */
  }, {
    key: "hashAccessScript",
    value: function hashAccessScript(script) {
      var _this$app$core;
      if (script === null || script === undefined) {
        return '';
      }
      if (!((_this$app$core = this.app.core) !== null && _this$app$core !== void 0 && (_this$app$core = _this$app$core.scripting) !== null && _this$app$core !== void 0 && _this$app$core.hash)) {
        console.warn('Stack: app.core.scripting.hash not available - cannot hash access script');
        return '';
      }
      var access_script = typeof script === 'string' ? script : JSON.stringify(script);
      return this.app.core.scripting.hash(access_script);
    }

    ////////////////////////////
    // Create Stack Post Transaction
    ////////////////////////////
    /**
     * Creates a new stack post transaction and propagates it to the network.
     *
     * @param {Object} post - The post data object
     * @param {string} post.title - The title of the post (required)
     * @param {string} post.content - The content/body of the post in Markdown format (required)
     * @param {string} post.image - Base64 encoded image data (optional)
     * @param {string} post.imageUrl - URL to an external image (optional)
     * @param {Array<string>} post.tags - Array of tag strings (optional, defaults to empty array)
     * @param {number} post.timestamp - Unix timestamp in milliseconds (optional, defaults to Date.now())
     * @param {string} post.subscriptionTier - Subscription tier: 'free' or 'paid' (optional, defaults to 'free')
     * @param {string} post.excerpt - Short excerpt/summary of the post (optional)
     * @param {Function} callback - Optional callback function to execute after post is confirmed
     *
     * @returns {Promise<Transaction>} The signed transaction object
     *
     * Transaction message (tx.msg) structure:
     * {
     *   module: 'Stack',
     *   request: 'create stack post request',
     *   data: {
     *     type: 'stack_post',
     *     title: string,           // Post title
     *     content: string,         // Markdown content
     *     image: string,           // Base64 image data (optional)
     *     images: array,           // JSON of (Base64 image data (optional))
     *     imageUrl: string,        // External image URL (optional)
     *     tags: Array<string>,     // Array of tags
     *     timestamp: number,       // Unix timestamp
     *     subscriptionTier: string, // 'free' or 'paid'
     *     excerpt: string          // Post excerpt (optional)
     *   }
     * }
     */
  }, {
    key: "createStackPostTransaction",
    value: function () {
      var _createStackPostTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var post,
          callback,
          newtx,
          data,
          publishIntent,
          accessLevel,
          access_script,
          access_hash,
          _args10 = arguments,
          _t5;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.p = _context10.n) {
            case 0:
              post = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {
                title: '',
                content: '',
                image: '',
                images: [],
                imageUrl: '',
                tags: [],
                timestamp: Date.now(),
                subscriptionTier: 'free',
                excerpt: '',
                accessLevel: 'public' // 'public' or 'private'
              };
              callback = _args10.length > 1 ? _args10[1] : undefined;
              _context10.p = 1;
              _context10.n = 2;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(this.publicKey);
            case 2:
              newtx = _context10.v;
              // Validate and sanitize the post data
              data = {
                type: 'stack_post',
                title: post.title || 'Untitled',
                content: typeof post.content === 'string' ? post.content : JSON.stringify(post.content),
                images: Array.isArray(post.images) ? post.images : [],
                // Embedded content images array
                tags: Array.isArray(post.tags) ? post.tags : [],
                image: post.image || '',
                // Teaser/header image (singular, separate)
                imageUrl: post.imageUrl || '',
                timestamp: post.timestamp || Date.now(),
                subscriptionTier: post.subscriptionTier || 'free',
                excerpt: post.excerpt || ''
              }; // --------------------------------------------------------------------
              // IMAGE INVARIANT ENFORCEMENT
              // Published posts MUST NOT contain raw data:image URLs in markdown.
              // All inline images must be converted to stack:image:<id> references
              // during serialization (editor → markdown).
              // --------------------------------------------------------------------
              if (!/!\[[^\]]*\]\(data:image\/[a-zA-Z+]+;base64,/i.test(data.content)) {
                _context10.n = 3;
                break;
              }
              throw new Error('Publish aborted: raw data:image URL found in post content. ' + 'Images must be published using stack:image:<id> references.');
            case 3:
              // PART 2 — TRANSACTION CREATION CHANGE: Include parent_id if editing
              // If parent_id is provided, this is an edit of an existing post
              if (post.parent_id) {
                data.parent_id = post.parent_id;
              }

              // ------------------------------------------------------------
              // AUTHORITATIVE ACCESS INTENT NORMALIZATION (SUBSCRIPTIONS)
              // ------------------------------------------------------------
              // This MUST run before publishIntent is constructed
              if (post.accessLevel === 'subscription') {
                post.publishIntent = {
                  visibility: 'subscription',
                  access_mode: post.access_mode || 'transferable',
                  time_limit: null,
                  author: this.publicKey
                };
              }

              // ========================================================================
              // ACCESS SCRIPT GENERATION: Deterministic pipeline from intent to hash
              // ========================================================================
              // 1. Generate normalized publish intent from post data
              // 2. Map intent to canonical access script template
              // 3. Hash the locking script
              // 4. Attach access_hash to transaction
              // ========================================================================

              // Generate publish intent (backward compatible with accessLevel string)

              if (post.publishIntent && _typeof(post.publishIntent) === 'object') {
                // New format: normalized intent object
                publishIntent = post.publishIntent;
                // Ensure author is set
                if (!publishIntent.author) {
                  publishIntent.author = this.publicKey;
                }
              } else {
                // Legacy format: convert accessLevel string to intent
                accessLevel = post.accessLevel || 'public';
                publishIntent = {
                  visibility: accessLevel,
                  access_mode: accessLevel === 'subscription' ? post.access_mode || 'transferable' : null,
                  time_limit: null,
                  author: this.publicKey
                };
              }
              console.log('PUBLISH INTENT:', publishIntent);

              // Get access script for intent
              access_script = null;
              access_hash = '';
              try {
                access_script = this.getAccessScriptForPublishIntent(publishIntent);

                // Initialize msg object if needed
                if (!newtx.msg) {
                  newtx.msg = {};
                }
                if (access_script !== null) {
                  // Private post: Hash the script and attach access_hash
                  access_hash = this.hashAccessScript(access_script);
                  if (access_hash) {
                    newtx.msg.access_script = JSON.stringify(access_script);
                    newtx.msg.access_hash = access_hash;
                  }
                } else {
                  // Public post: access_hash must be ABSENT, not null
                  // Explicitly delete if it exists (e.g., switching from private to public)
                  if (newtx.msg.access_hash !== undefined) {
                    delete newtx.msg.access_hash;
                  }
                  // Also remove access_script if present
                  if (newtx.msg.access_script !== undefined) {
                    delete newtx.msg.access_script;
                  }
                }
              } catch (error) {
                console.error('Stack: Error generating access script:', error);
                // Fail safely: for public posts, ensure access_hash is absent
                if (!newtx.msg) {
                  newtx.msg = {};
                }
                // If visibility is public, ensure access_hash is deleted
                if (publishIntent.visibility === 'public') {
                  if (newtx.msg.access_hash !== undefined) {
                    delete newtx.msg.access_hash;
                  }
                }
              }

              // Set the transaction message
              newtx.msg = _objectSpread(_objectSpread({}, newtx.msg), {}, {
                module: this.name,
                request: 'create stack post request',
                data: data
              });
              _context10.n = 4;
              return newtx.sign();
            case 4:
              siteMessage('Publishing...', 3000);
              _context10.n = 5;
              return this.app.network.propagateTransaction(newtx);
            case 5:
              if (callback) {
                this.callbackAfterPost = callback;
              }
              return _context10.a(2, newtx);
            case 6:
              _context10.p = 6;
              _t5 = _context10.v;
              console.error('Error creating stack post transaction:', _t5);
              siteMessage('Unable to create post transaction', 3000);
              throw _t5;
            case 7:
              return _context10.a(2);
          }
        }, _callee10, this, [[1, 6]]);
      }));
      function createStackPostTransaction() {
        return _createStackPostTransaction.apply(this, arguments);
      }
      return createStackPostTransaction;
    }() ////////////////////////////
    // Logical Post Identity Helper
    ////////////////////////////
    /**
     * Returns the canonical logical post ID for a transaction.
     *
     * A Stack post is a LOGICAL OBJECT WITH REVISIONS, not a single transaction.
     * Multiple transactions can represent the same logical post:
     * - Root post: signature = sigA, parent_id = null → logical ID = sigA
     * - Edited post: signature = sigAA, parent_id = sigA → logical ID = sigA
     *
     * This is the AUTHORITATIVE definition of logical post identity.
     * Do NOT re-derive this logic elsewhere.
     *
     * @param {Transaction} tx - The transaction to get logical post ID for
     * @returns {string} The logical post ID (parent_id for revisions, signature for roots)
     */
  }, {
    key: "getLogicalPostId",
    value: function getLogicalPostId(tx) {
      if (!tx) {
        throw new Error('getLogicalPostId: tx is required');
      }
      try {
        var _txmsg$data;
        var txmsg = tx.returnMessage();
        var parent_id = (txmsg === null || txmsg === void 0 || (_txmsg$data = txmsg.data) === null || _txmsg$data === void 0 ? void 0 : _txmsg$data.parent_id) || null;

        // Logical post identity = parent_id || signature
        // For revisions: use parent_id (the root post signature)
        // For root posts: use their own signature
        return parent_id || tx.signature;
      } catch (error) {
        // Fallback to signature if message parsing fails
        console.warn('Stack: Error computing logical post ID, falling back to signature:', error);
        return tx.signature || '';
      }
    }

    /**
     * Returns the canonical logical post ID for a cached post object.
     *
     * Cached post objects have { sig, parent_id, ... } structure.
     * This uses the same logical post identity rule as getLogicalPostId(tx).
     *
     * @param {Object} post - The cached post object with sig and parent_id fields
     * @returns {string} The logical post ID (parent_id for revisions, sig for roots)
     */
  }, {
    key: "getLogicalPostIdFromPost",
    value: function getLogicalPostIdFromPost(post) {
      if (!post) {
        throw new Error('getLogicalPostIdFromPost: post is required');
      }

      // Logical post identity = parent_id || sig
      // For revisions: use parent_id (the root post signature)
      // For root posts: use their own signature
      return post.parent_id || post.sig || '';
    }

    ////////////////////////////
    // Receive Stack Post Transaction
    ////////////////////////////
    ////////////////////////////
    // Archive Handler for Blog Posts
    ////////////////////////////
    /**
     * Handles archive management for Stack blog posts.
     * This is the SINGLE place managing Stack archive writes.
     *
     * For revisions (parent_id exists):
     * - Deletes older revisions with same (author, parent_id)
     * - Saves latest revision with preserve = 1
     *
     * For root posts (parent_id is null):
     * - Saves with preserve = 1
     *
     * @param {Transaction} tx - The confirmed transaction
     * @param {Block} blk - The block containing the transaction
     */
  }, {
    key: "onReceiveBlogPost",
    value: function () {
      var _onReceiveBlogPost = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(tx, blk) {
        var _txmsg$data2,
          _txmsg$data3,
          _tx$msg,
          _this5 = this;
        var txmsg, author, signature, parent_id, archiveData, access_hash, olderRevisions, _iterator3, _step3, oldTx, _t6, _t7, _t8;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.p = _context11.n) {
            case 0:
              if (!(!tx || !tx.msg || !tx.from || !tx.from[0])) {
                _context11.n = 1;
                break;
              }
              return _context11.a(2);
            case 1:
              txmsg = tx.returnMessage(); // Never touch non-Stack transactions
              if (!(txmsg.module !== this.name || txmsg.request !== 'create stack post request')) {
                _context11.n = 2;
                break;
              }
              return _context11.a(2);
            case 2:
              if (!(((_txmsg$data2 = txmsg.data) === null || _txmsg$data2 === void 0 ? void 0 : _txmsg$data2.type) !== 'stack_post')) {
                _context11.n = 3;
                break;
              }
              return _context11.a(2);
            case 3:
              // Extract required data
              author = tx.from[0].publicKey;
              signature = tx.signature;
              parent_id = ((_txmsg$data3 = txmsg.data) === null || _txmsg$data3 === void 0 ? void 0 : _txmsg$data3.parent_id) || null; // Prepare archive metadata
              archiveData = {
                field1: 'Stack',
                // Explicitly set (though may be auto-set)
                field2: author,
                field4: 'stack:post',
                field5: parent_id || '',
                // Empty string for root posts, parent_id for revisions
                preserve: 1
              }; // Set owner field for private posts (required for access_hash enforcement)
              // If access_hash exists, this is a private post and needs owner set
              // Check both txmsg.access_hash (from returnMessage) and tx.msg.access_hash (direct)
              access_hash = txmsg.access_hash || ((_tx$msg = tx.msg) === null || _tx$msg === void 0 ? void 0 : _tx$msg.access_hash);
              if (access_hash) {
                archiveData.owner = access_hash;
              }

              // If parent_id EXISTS: delete older revisions
              if (!parent_id) {
                _context11.n = 14;
                break;
              }
              _context11.n = 4;
              return new Promise(function (resolve) {
                _this5.app.storage.loadTransactions({
                  field1: 'Stack',
                  field2: author,
                  field4: 'stack:post',
                  field5: parent_id
                }, function (txs) {
                  resolve(txs || []);
                }, 'localhost' // CRITICAL: Only query localhost, never remote peers
                );
              });
            case 4:
              olderRevisions = _context11.v;
              // Delete ALL matches (these are older revisions)
              _iterator3 = _createForOfIteratorHelper(olderRevisions);
              _context11.p = 5;
              _iterator3.s();
            case 6:
              if ((_step3 = _iterator3.n()).done) {
                _context11.n = 11;
                break;
              }
              oldTx = _step3.value;
              if (!(oldTx.signature !== signature)) {
                _context11.n = 10;
                break;
              }
              _context11.p = 7;
              _context11.n = 8;
              return this.app.storage.deleteTransaction(oldTx, null, 'localhost');
            case 8:
              _context11.n = 10;
              break;
            case 9:
              _context11.p = 9;
              _t6 = _context11.v;
              console.warn('Stack: Error deleting older revision:', _t6);
            // Fail silently - continue with save
            case 10:
              _context11.n = 6;
              break;
            case 11:
              _context11.n = 13;
              break;
            case 12:
              _context11.p = 12;
              _t7 = _context11.v;
              _iterator3.e(_t7);
            case 13:
              _context11.p = 13;
              _iterator3.f();
              return _context11.f(13);
            case 14:
              _context11.p = 14;
              _context11.n = 15;
              return this.app.storage.saveTransaction(tx, archiveData, 'localhost', blk);
            case 15:
              _context11.n = 17;
              break;
            case 16:
              _context11.p = 16;
              _t8 = _context11.v;
              console.warn('Stack: Error saving blog post to archive:', _t8);
            // Fail silently
            case 17:
              return _context11.a(2);
          }
        }, _callee11, this, [[14, 16], [7, 9], [5, 12, 13, 14]]);
      }));
      function onReceiveBlogPost(_x0, _x1) {
        return _onReceiveBlogPost.apply(this, arguments);
      }
      return onReceiveBlogPost;
    }() ////////////////////////////
    // Receive Stack Post Transaction
    ////////////////////////////
    /**
     * Handles receiving and processing a stack post transaction.
     * Called automatically when a stack post transaction is confirmed on the network.
     * Handles caching and UI updates only - archive management is in onReceiveBlogPost().
     *
     * @param {Transaction} tx - The confirmed transaction
     * @param {Block} blk - The block containing the transaction
     */
  }, {
    key: "receiveStackPostTransaction",
    value: function () {
      var _receiveStackPostTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(tx, blk) {
        var _tx$from$,
          _txmsg$data4,
          _this6 = this;
        var from, txmsg, parent_id, post, incomingLogicalPostId, _authorPosts, filteredAuthorPosts, existingInAllPosts, authorPosts, existingInAuthorPosts, _txmsg$data5, _parent_id, lightweightPost, _incomingLogicalPostId, postIndex, _txmsg$data6, _txmsg, _parent_id2;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              from = tx === null || tx === void 0 || (_tx$from$ = tx.from[0]) === null || _tx$from$ === void 0 ? void 0 : _tx$from$.publicKey;
              if (from) {
                _context12.n = 1;
                break;
              }
              console.error('Stack: Invalid TX');
              return _context12.a(2);
            case 1:
              txmsg = tx.returnMessage(); // Extract parent_id from transaction data (source of truth)
              parent_id = ((_txmsg$data4 = txmsg.data) === null || _txmsg$data4 === void 0 ? void 0 : _txmsg$data4.parent_id) || null;
              post = _objectSpread(_objectSpread({}, txmsg.data), {}, {
                sig: tx.signature,
                publicKey: tx.from[0].publicKey,
                timestamp: txmsg.data.timestamp || tx.timestamp,
                lastEdited: txmsg.data.timestamp || tx.timestamp
              }); // Add to transactionCache
              if (tx.signature) {
                this.transactionCache[tx.signature] = tx;
              }

              // ISSUE 2 — DUPLICATE POSTS AFTER EDITING: Remove old versions before adding new one
              // Compute logical post ID for this transaction
              incomingLogicalPostId = this.getLogicalPostId(tx); // Remove older versions of the same logical post from cache
              // Filter out any cached posts that belong to the same logical post
              this.postsCache.allPosts = this.postsCache.allPosts.filter(function (p) {
                return _this6.getLogicalPostIdFromPost(p) !== incomingLogicalPostId;
              });

              // Remove from byAuthor cache
              if (this.postsCache.byAuthor.has(from)) {
                _authorPosts = this.postsCache.byAuthor.get(from);
                filteredAuthorPosts = _authorPosts.filter(function (p) {
                  return _this6.getLogicalPostIdFromPost(p) !== incomingLogicalPostId;
                });
                this.postsCache.byAuthor.set(from, filteredAuthorPosts);
              }

              // Add to cache (check for duplicates to avoid adding the same post twice)
              // This can happen if post was added optimistically during publish
              existingInAllPosts = this.postsCache.allPosts.findIndex(function (p) {
                return p.sig === tx.signature;
              });
              if (existingInAllPosts < 0) {
                // Add parent_id to post object for future deduplication
                post.parent_id = parent_id;
                this.postsCache.allPosts.push(post);
              } else {
                // Update existing entry in case data changed
                this.postsCache.allPosts[existingInAllPosts] = post;
                this.postsCache.allPosts[existingInAllPosts].parent_id = parent_id;
              }

              // Also cache by author (check for duplicates)
              if (!this.postsCache.byAuthor.has(from)) {
                this.postsCache.byAuthor.set(from, []);
              }
              authorPosts = this.postsCache.byAuthor.get(from);
              existingInAuthorPosts = authorPosts.findIndex(function (p) {
                return p.sig === tx.signature;
              });
              if (existingInAuthorPosts < 0) {
                // Add parent_id to post object for future deduplication
                post.parent_id = parent_id;
                authorPosts.push(post);
              } else {
                // Update existing entry in case data changed
                authorPosts[existingInAuthorPosts] = post;
                authorPosts[existingInAuthorPosts].parent_id = parent_id;
              }

              // ========================================================================
              // Save lightweight reference to app.options.stack.posts (only for user's own posts)
              // INVARIANT: app.options.stack is lightweight - no post bodies, images, or heavy data
              // ========================================================================
              if (tx.isFrom(this.publicKey)) {
                // Extract parent_id for revision tracking
                _parent_id = ((_txmsg$data5 = txmsg.data) === null || _txmsg$data5 === void 0 ? void 0 : _txmsg$data5.parent_id) || null; // Store only lightweight reference (sig, publicKey, timestamp, status, parent_id)
                // Full content must be loaded from archive when needed
                lightweightPost = {
                  sig: tx.signature,
                  publicKey: tx.from[0].publicKey,
                  timestamp: txmsg.data.timestamp || tx.timestamp,
                  lastEdited: txmsg.data.timestamp || tx.timestamp,
                  status: 'published',
                  // Can be 'published', 'unpublished', etc.
                  parent_id: _parent_id || null // null for root posts, parent signature for revisions
                }; // Find existing entry for this logical post using canonical helper
                _incomingLogicalPostId = this.getLogicalPostId(tx);
                postIndex = this.app.options.stack.posts.findIndex(function (p) {
                  return _this6.getLogicalPostIdFromPost(p) === _incomingLogicalPostId;
                });
                if (postIndex >= 0) {
                  // Update existing post entry with latest revision info
                  this.app.options.stack.posts[postIndex] = lightweightPost;
                } else {
                  // Post not in list yet - add this revision
                  this.app.options.stack.posts.push(lightweightPost);
                }
                this.save();
              }
              if (this.app.BROWSER) {
                if (tx.isFrom(this.publicKey)) {
                  // Check if this is an update (has parent_id) or new post
                  _txmsg = tx.returnMessage();
                  _parent_id2 = ((_txmsg$data6 = _txmsg.data) === null || _txmsg$data6 === void 0 ? void 0 : _txmsg$data6.parent_id) || null;
                  if (_parent_id2) {
                    siteMessage('Post updated', 1500);
                  } else {
                    siteMessage('Stack post published', 1500);
                  }

                  // Browser-only confirmation alert for testing
                  if (this.browser_active) {
                    siteMessage('Your blog post has been received from the network.');
                  }
                } else {
                  siteMessage("New stack post by ".concat(this.app.keychain.returnUsername(from)), 3000);
                }
              }

              // Archive management is now handled by onReceiveBlogPost() in onConfirmation()
              // This function only handles caching and UI updates

              if (this.callbackAfterPost) {
                this.callbackAfterPost();
                delete this.callbackAfterPost;
              }
            case 2:
              return _context12.a(2);
          }
        }, _callee12, this);
      }));
      function receiveStackPostTransaction(_x10, _x11) {
        return _receiveStackPostTransaction.apply(this, arguments);
      }
      return receiveStackPostTransaction;
    }()
    /**
     * Clean up pending drafts after a post is confirmed
     * Deletes all transactions with field4 = "stack:pending" owned by this user from localhost archive
     */
  }, {
    key: "cleanupPendingDrafts",
    value: function () {
      var _cleanupPendingDrafts = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14() {
        var _this7 = this;
        var _t1;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.p = _context14.n) {
            case 0:
              _context14.p = 0;
              return _context14.a(2, new Promise(function (resolve) {
                _this7.app.storage.loadTransactions({
                  field1: 'Stack',
                  field2: _this7.publicKey,
                  // Only clean up this user's pending drafts
                  field4: 'stack:pending'
                }, /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(txs) {
                    var _iterator4, _step4, pendingTx, _t9, _t0;
                    return _regenerator().w(function (_context13) {
                      while (1) switch (_context13.p = _context13.n) {
                        case 0:
                          if (!(!txs || txs.length === 0)) {
                            _context13.n = 1;
                            break;
                          }
                          resolve();
                          return _context13.a(2);
                        case 1:
                          // Delete all pending draft transactions
                          _iterator4 = _createForOfIteratorHelper(txs);
                          _context13.p = 2;
                          _iterator4.s();
                        case 3:
                          if ((_step4 = _iterator4.n()).done) {
                            _context13.n = 8;
                            break;
                          }
                          pendingTx = _step4.value;
                          _context13.p = 4;
                          _context13.n = 5;
                          return _this7.app.storage.deleteTransaction(pendingTx, null, 'localhost');
                        case 5:
                          _context13.n = 7;
                          break;
                        case 6:
                          _context13.p = 6;
                          _t9 = _context13.v;
                          console.error('Error deleting pending draft:', _t9);
                        case 7:
                          _context13.n = 3;
                          break;
                        case 8:
                          _context13.n = 10;
                          break;
                        case 9:
                          _context13.p = 9;
                          _t0 = _context13.v;
                          _iterator4.e(_t0);
                        case 10:
                          _context13.p = 10;
                          _iterator4.f();
                          return _context13.f(10);
                        case 11:
                          resolve();
                        case 12:
                          return _context13.a(2);
                      }
                    }, _callee13, null, [[4, 6], [2, 9, 10, 11]]);
                  }));
                  return function (_x12) {
                    return _ref2.apply(this, arguments);
                  };
                }(), 'localhost');
              }));
            case 1:
              _context14.p = 1;
              _t1 = _context14.v;
              console.error('Error cleaning up pending drafts:', _t1);
            case 2:
              return _context14.a(2);
          }
        }, _callee14, null, [[0, 1]]);
      }));
      function cleanupPendingDrafts() {
        return _cleanupPendingDrafts.apply(this, arguments);
      }
      return cleanupPendingDrafts;
    }() ////////////////////////////
    // Local State Management //
    ////////////////////////////
    /**
     * Load persistent local UX state from app.options.
     * Initializes app.options.stack defaults if they do not already exist.
     * This is CLIENT-SIDE STATE ONLY - not authoritative.
     *
     * Structure:
     * app.options.stack = {
     *   posts: [ { sig, publicKey, timestamp, lastEdited, status } ],  // Lightweight references only
     *   subscriptions: [ { publicKey, addedAt } ],  // List of subscribed creator publicKeys
     *   has_created_keys: false  // Whether user has created Stack access / subscription keys
     * }
     */
  }, {
    key: "load",
    value: function load() {
      if (!this.app.options.stack) {
        this.app.options.stack = {};
      }
      if (!this.app.options.stack.posts) {
        this.app.options.stack.posts = [];
      }
      if (!this.app.options.stack.subscriptions) {
        this.app.options.stack.subscriptions = [];
      }
      if (this.app.options.stack.has_created_keys === undefined) {
        this.app.options.stack.has_created_keys = false;
      }
      // Note: app.options.stack is lightweight - no post bodies, images, or heavy data
      // Full post content must be loaded from archive transactions when needed

      return this.app.options.stack;
    }

    ////////////////////////////
    // Subscription Management //
    ////////////////////////////
    /**
     * Add a subscription to a creator by publicKey
     * @param {string} publicKey - The creator's publicKey
     * @returns {boolean} - True if added, false if already subscribed
     */
  }, {
    key: "addSubscription",
    value: function addSubscription(publicKey) {
      if (!publicKey || !this.app.crypto.isPublicKey(publicKey)) {
        return false;
      }
      if (this.isSubscribed(publicKey)) {
        return false;
      }

      // Add subscription
      this.app.options.stack.subscriptions.push({
        publicKey: publicKey,
        addedAt: Date.now()
      });
      this.save();
      return true;
    }

    /**
     * Check if a publicKey is subscribed
     * @param {string} publicKey - The creator's publicKey
     * @returns {boolean}
     */
  }, {
    key: "isSubscribed",
    value: function isSubscribed(publicKey) {
      if (!publicKey) return false;
      if (publicKey == this.publicKey || publicKey == this.STACK_OFFICIAL_PUBLICKEY) {
        return true;
      }
      var subscriptions = this.app.options.stack.subscriptions || [];
      return subscriptions.some(function (sub) {
        return sub.publicKey === publicKey;
      });
    }

    /**
     * Get all subscribed publicKeys
     * @returns {Array<string>}
     */
  }, {
    key: "getSubscriptions",
    value: function getSubscriptions() {
      var subscriptions = this.app.options.stack.subscriptions || [];
      return subscriptions.map(function (sub) {
        return sub.publicKey;
      });
    }

    /**
     * Save persistent local UX state to app.options
     * Persists app.options.stack using app.storage.saveOptions()
     * This is CLIENT-SIDE STATE ONLY - not authoritative
     */
  }, {
    key: "save",
    value: function save() {
      this.app.storage.saveOptions();
    }

    ////////////////////////////
    // Draft & Publish State  //
    ////////////////////////////
    /**
     * Check if the user has ever published a blog post
     * Uses postsCache.byAuthor to determine if user's publicKey appears as a publisher
     * @returns {boolean} True if user has published at least one post
     */
  }, {
    key: "hasPublished",
    value: function hasPublished() {
      if (!this.publicKey) {
        return false;
      }
      return this.postsCache.byAuthor.has(this.publicKey) && this.postsCache.byAuthor.get(this.publicKey).length > 0;
    }

    /**
     * Discover all local draft transactions from the archive
     * Stores pruned representation in-memory (this.drafts)
     * Ordered by last-modified DESC (most recent first)
     * Non-blocking, can be called on render/activation
     */
  }, {
    key: "discoverDrafts",
    value: function () {
      var _discoverDrafts = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15() {
        var _this8 = this;
        var queryParams;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.n) {
            case 0:
              // ========================================================================
              // DIAGNOSTIC: Log entry into discoverDrafts()
              // ========================================================================
              console.log('[DIAG] discoverDrafts() ENTRY');
              if (this.app.storage) {
                _context15.n = 1;
                break;
              }
              console.log('[DIAG] discoverDrafts() EARLY RETURN: this.app.storage is not available');
              return _context15.a(2);
            case 1:
              // ========================================================================
              // DIAGNOSTIC: Log query parameters
              // ========================================================================
              queryParams = {
                field1: 'Stack',
                field4: 'stack:draft'
              }; // console.log('[DIAG] discoverDrafts() Query parameters:', JSON.stringify(queryParams, null, 2));
              // console.log('[DIAG] discoverDrafts() Query peer: localhost');
              // console.log(
              //   '[DIAG] discoverDrafts() Expected match: field1="Stack" AND field4="stack:draft" AND peer="localhost"'
              // );
              return _context15.a(2, new Promise(function (resolve) {
                _this8.app.storage.loadTransactions(queryParams, function (txs) {
                  // ========================================================================
                  // DIAGNOSTIC: Log raw results count
                  // ========================================================================
                  var rawCount = txs ? txs.length : 0;
                  console.log('[DIAG] discoverDrafts() Raw results count:', rawCount);

                  // ========================================================================
                  // DIAGNOSTIC: Log field values of returned transactions for comparison
                  // ========================================================================
                  if (txs && txs.length > 0) {
                    console.log('[DIAG] discoverDrafts() Returned transactions have the following field values:');
                    txs.forEach(function (tx, idx) {
                      console.log("[DIAG]   Transaction ".concat(idx + 1, ":"));
                      console.log("[DIAG]     - field1: \"".concat(tx.field1 || 'N/A', "\""));
                      console.log("[DIAG]     - field2: \"".concat(tx.field2 || 'N/A', "\""));
                      console.log("[DIAG]     - field4: \"".concat(tx.field4 || 'N/A', "\""));
                      console.log("[DIAG]     - signature: ".concat(tx.signature || 'N/A'));
                    });
                  } else {
                    console.log('[DIAG] discoverDrafts() No transactions returned - checking if ANY drafts exist with different field values...');

                    // ========================================================================
                    // DIAGNOSTIC: Try querying with just field4 to see if drafts exist with different field1
                    // ========================================================================
                    _this8.app.storage.loadTransactions({
                      field4: 'stack:draft'
                    }, function (allDrafts) {
                      var allDraftsCount = allDrafts ? allDrafts.length : 0;
                      console.log('[DIAG] discoverDrafts() Query with ONLY field4="stack:draft" found', allDraftsCount, 'transactions');
                      if (allDrafts && allDraftsCount > 0) {
                        console.log('[DIAG] discoverDrafts() These drafts have the following field values:');
                        allDrafts.forEach(function (tx, idx) {
                          console.log("[DIAG]   Draft ".concat(idx + 1, ":"));
                          console.log("[DIAG]     - field1: \"".concat(tx.field1 || 'N/A', "\" (query expected \"Stack\")"));
                          console.log("[DIAG]     - field2: \"".concat(tx.field2 || 'N/A', "\""));
                          console.log("[DIAG]     - field4: \"".concat(tx.field4 || 'N/A', "\" (matches)"));
                          console.log("[DIAG]     - signature: ".concat(tx.signature || 'N/A'));
                        });
                      }
                    }, 'localhost');
                  }
                  if (!txs || txs.length === 0) {
                    _this8.drafts = [];

                    // Log draftCount after discovery (downgraded from diagnostic)
                    console.debug('Stack: discoverDrafts() completed. draftCount = 0');
                    console.log('[DIAG] discoverDrafts() EXIT: No drafts found');
                    resolve();
                    return;
                  }

                  // Extract pruned draft representation
                  var draftList = txs.map(function (tx) {
                    var title = 'Untitled draft';
                    var lastModified = tx.timestamp || 0;
                    try {
                      var msg = tx.returnMessage();
                      if (msg && msg.data) {
                        var _tx$optional;
                        title = msg.data.title || title;
                        // Use optional.updated_at if available, otherwise timestamp
                        lastModified = ((_tx$optional = tx.optional) === null || _tx$optional === void 0 ? void 0 : _tx$optional.updated_at) || tx.timestamp || 0;
                      }
                    } catch (err) {
                      // If transaction can't be parsed, use defaults
                      console.warn('Stack: Error parsing draft transaction:', err);
                    }
                    return {
                      id: tx.signature || tx.hash || null,
                      // Transaction identifier
                      title: title,
                      lastModified: lastModified
                    };
                  });

                  // Sort by lastModified DESC (most recent first)
                  draftList.sort(function (a, b) {
                    return b.lastModified - a.lastModified;
                  });
                  _this8.drafts = draftList;

                  // ========================================================================
                  // DIAGNOSTIC: Log parsed drafts added to this.mod.drafts
                  // ========================================================================
                  console.log('[DIAG] discoverDrafts() Parsed drafts added to this.mod.drafts:', JSON.stringify(draftList, null, 2));

                  // Log draftCount after discovery (downgraded from diagnostic)
                  console.debug("Stack: discoverDrafts() completed. draftCount = ".concat(draftList.length));
                  console.log('[DIAG] discoverDrafts() EXIT: Drafts found and parsed');
                  resolve();
                }, 'localhost');
              }));
          }
        }, _callee15, this);
      }));
      function discoverDrafts() {
        return _discoverDrafts.apply(this, arguments);
      }
      return discoverDrafts;
    }()
    /**
     * Get the list of drafts (read-only)
     * @returns {Array} Array of draft objects with {id, title, lastModified}, ordered by recency
     */
  }, {
    key: "getDrafts",
    value: function getDrafts() {
      return this.drafts.slice(); // Return a copy to prevent mutation
    }

    /**
     * Check if there are any valid drafts available
     *
     * INVARIANT: Centralized function for determining draft existence
     * Filters drafts defensively to exclude:
     * - null/undefined entries
     * - malformed entries without valid IDs
     * - published drafts (checked against postsCache)
     *
     * All UI and editor logic must rely on this function.
     * No other draft-count logic is allowed.
     *
     * @returns {boolean} True if at least one valid draft exists, false otherwise
     */
  }, {
    key: "hasValidDrafts",
    value: function hasValidDrafts() {
      var _this9 = this;
      // ========================================================================
      // [DRAFT-CHECK] Log entry
      // ========================================================================
      console.log('[DRAFT-CHECK] hasValidDrafts() called');
      var draftsBeforeFilter = this.drafts ? this.drafts.length : 0;
      console.log('[DRAFT-CHECK] drafts_before_filter =', draftsBeforeFilter);

      // Defensive check: if drafts array is null/undefined/empty, return false
      if (!this.drafts || this.drafts.length === 0) {
        console.log('[DRAFT-CHECK] drafts_after_filter = 0 (array empty or null)');
        console.log('[DRAFT-CHECK] hasValidDrafts() returning false');
        return false;
      }

      // Filter drafts defensively
      var validDrafts = this.drafts.filter(function (draft) {
        // Exclude null/undefined entries
        if (!draft) {
          console.log('[DRAFT-CHECK] Filtering out null/undefined draft entry');
          return false;
        }

        // Exclude entries without valid IDs
        if (!draft.id || typeof draft.id !== 'string' || draft.id.trim() === '') {
          console.log('[DRAFT-CHECK] Filtering out draft without valid ID:', draft);
          return false;
        }

        // Check if draft has been published (exists in postsCache)
        // Published drafts should not appear in draft chooser
        if (_this9.postsCache && _this9.postsCache.allPosts) {
          var isPublished = _this9.postsCache.allPosts.some(function (post) {
            return post.sig === draft.id;
          });
          if (isPublished) {
            console.log('[DRAFT-CHECK] Filtering out published draft:', draft.id);
            return false;
          }
        }

        // Draft is valid
        return true;
      });
      var draftsAfterFilter = validDrafts.length;
      console.log('[DRAFT-CHECK] drafts_after_filter =', draftsAfterFilter);
      console.log('[DRAFT-CHECK] hasValidDrafts() returning', draftsAfterFilter > 0);
      return draftsAfterFilter > 0;
    }

    /**
     * Refresh draft list from archive
     * Call this after draft save/delete/publish operations
     */
  }, {
    key: "refreshDrafts",
    value: function () {
      var _refreshDrafts = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16() {
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.n) {
            case 0:
              _context16.n = 1;
              return this.discoverDrafts();
            case 1:
              return _context16.a(2);
          }
        }, _callee16, this);
      }));
      function refreshDrafts() {
        return _refreshDrafts.apply(this, arguments);
      }
      return refreshDrafts;
    }()
    /**
     * Delete a draft transaction by ID (signature or hash)
     * Updates both local archive and in-memory draft list
     * @param {string} draftId - Transaction signature or hash
     * @returns {Promise<boolean>} True if draft was deleted, false otherwise
     */
  }, {
    key: "deleteDraft",
    value: function () {
      var _deleteDraft = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(draftId) {
        var tx, stillExists, _t10;
        return _regenerator().w(function (_context17) {
          while (1) switch (_context17.p = _context17.n) {
            case 0:
              if (draftId) {
                _context17.n = 1;
                break;
              }
              return _context17.a(2, false);
            case 1:
              _context17.p = 1;
              // [DRAFT-CHECK] Log draft deletion
              console.log('[DRAFT-CHECK] deleteDraft() called for draftId:', draftId);

              // Load the draft transaction to delete
              _context17.n = 2;
              return this.loadDraftTransactionById(draftId);
            case 2:
              tx = _context17.v;
              if (tx) {
                _context17.n = 3;
                break;
              }
              console.warn('[DRAFT-CHECK] Draft transaction not found for deletion:', draftId);
              return _context17.a(2, false);
            case 3:
              _context17.n = 4;
              return this.app.storage.deleteTransaction(tx, null, 'localhost');
            case 4:
              console.log('[DRAFT-CHECK] Draft deleted from archive');

              // Refresh in-memory draft list (this removes it from this.drafts)
              _context17.n = 5;
              return this.refreshDrafts();
            case 5:
              console.log('[DRAFT-CHECK] In-memory draft list refreshed - draft removed');

              // Verify draft is gone
              stillExists = this.drafts.some(function (d) {
                return d.id === draftId;
              });
              if (stillExists) {
                console.warn('[DRAFT-CHECK] WARNING: Draft still exists in memory after deletion!');
              } else {
                console.log('[DRAFT-CHECK] Draft successfully removed from memory');
              }
              return _context17.a(2, true);
            case 6:
              _context17.p = 6;
              _t10 = _context17.v;
              console.error('[DRAFT-CHECK] Error deleting draft:', _t10);
              return _context17.a(2, false);
          }
        }, _callee17, this, [[1, 6]]);
      }));
      function deleteDraft(_x13) {
        return _deleteDraft.apply(this, arguments);
      }
      return deleteDraft;
    }()
    /**
     * Load a draft transaction by ID (signature or hash)
     * Internal helper for draft operations
     */
  }, {
    key: "loadDraftTransactionById",
    value: function () {
      var _loadDraftTransactionById = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(draftId) {
        var _this0 = this;
        return _regenerator().w(function (_context18) {
          while (1) switch (_context18.n) {
            case 0:
              return _context18.a(2, new Promise(function (resolve) {
                _this0.app.storage.loadTransactions({
                  field1: 'Stack',
                  field4: 'stack:draft'
                }, function (txs) {
                  if (!txs || txs.length === 0) {
                    resolve(null);
                    return;
                  }

                  // Find transaction by signature or hash
                  var tx = txs.find(function (t) {
                    return t.signature === draftId || t.hash === draftId;
                  });
                  resolve(tx || null);
                }, 'localhost');
              }));
          }
        }, _callee18);
      }));
      function loadDraftTransactionById(_x14) {
        return _loadDraftTransactionById.apply(this, arguments);
      }
      return loadDraftTransactionById;
    }() ////////////////////////////
    // Peer Service Handling //
    ////////////////////////////
    /**
     * Handles incoming Stack service requests from peers.
     * Serves cached posts to requesting peers.
     * Follows RedSquare pattern for service request handling.
     *
     * @param {Object} app - Saito application instance
     * @param {Transaction} tx - Request transaction from peer
     * @param {Object} peer - Peer object making the request
     * @param {Function} mycallback - Callback to send response
     * @returns {number} 1 if handled, 0 if not handled
     */
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19(app) {
        var _this1 = this;
        var tx,
          peer,
          mycallback,
          txmsg,
          _txmsg$data7,
          signature,
          cachedTx,
          serialized,
          _txmsg$data8,
          _txmsg$data9,
          _txmsg$data0,
          _txmsg$data1,
          field1,
          field2,
          field4,
          access_witness,
          query,
          _txmsg$data10,
          serializedTx,
          _receivedMsg$data,
          receivedTx,
          receivedMsg,
          sig,
          _args19 = arguments,
          _t11;
        return _regenerator().w(function (_context19) {
          while (1) switch (_context19.p = _context19.n) {
            case 0:
              tx = _args19.length > 1 && _args19[1] !== undefined ? _args19[1] : null;
              peer = _args19.length > 2 ? _args19[2] : undefined;
              mycallback = _args19.length > 3 ? _args19[3] : undefined;
              if (!(tx == null || !mycallback)) {
                _context19.n = 1;
                break;
              }
              return _context19.a(2, 0);
            case 1:
              txmsg = tx.returnMessage();
              if (!(!txmsg || !txmsg.request)) {
                _context19.n = 2;
                break;
              }
              return _context19.a(2, 0);
            case 2:
              if (!(txmsg.request === 'load stack post')) {
                _context19.n = 5;
                break;
              }
              signature = (_txmsg$data7 = txmsg.data) === null || _txmsg$data7 === void 0 ? void 0 : _txmsg$data7.signature;
              if (!(!signature || typeof signature !== 'string')) {
                _context19.n = 3;
                break;
              }
              // Invalid request - respond with empty array
              mycallback([]);
              return _context19.a(2, 1);
            case 3:
              if (!this.transactionCache[signature]) {
                _context19.n = 4;
                break;
              }
              cachedTx = this.transactionCache[signature]; // Serialize transaction for network transmission
              serialized = cachedTx.serialize_to_web(app);
              mycallback([serialized]);
              return _context19.a(2, 1);
            case 4:
              // Not in cache - try local archive as fallback
              // This allows servers to serve posts they've recently loaded
              this.app.storage.loadTransactions({
                field1: 'Stack',
                signature: signature
              }, function (txs) {
                if (Array.isArray(txs) && txs.length > 0) {
                  var foundTx = txs.find(function (t) {
                    return t.signature === signature;
                  });
                  if (foundTx) {
                    // Cache it for future requests
                    _this1.transactionCache[signature] = foundTx;
                    var _serialized = foundTx.serialize_to_web(app);
                    mycallback([_serialized]);
                    return;
                  }
                }
                // Not found - respond with empty array (normal, not an error)
                mycallback([]);
              }, 'localhost');
              return _context19.a(2, 1);
            case 5:
              if (!(txmsg.request === 'load stack posts for author')) {
                _context19.n = 7;
                break;
              }
              field1 = (_txmsg$data8 = txmsg.data) === null || _txmsg$data8 === void 0 ? void 0 : _txmsg$data8.field1;
              field2 = (_txmsg$data9 = txmsg.data) === null || _txmsg$data9 === void 0 ? void 0 : _txmsg$data9.field2;
              field4 = (_txmsg$data0 = txmsg.data) === null || _txmsg$data0 === void 0 ? void 0 : _txmsg$data0.field4;
              access_witness = (_txmsg$data1 = txmsg.data) === null || _txmsg$data1 === void 0 ? void 0 : _txmsg$data1.access_witness;
              if (!(!field1 || !field2 || !field4)) {
                _context19.n = 6;
                break;
              }
              mycallback([]);
              return _context19.a(2, 1);
            case 6:
              query = {
                field1: field1,
                field2: field2,
                field4: field4,
                request_tx: tx
              };
              if (access_witness) {
                query.access_witness = access_witness;
              }
              this.app.storage.loadTransactions(query, function (txs) {
                var serialized = [];
                if (Array.isArray(txs)) {
                  for (var i = 0; i < txs.length; i++) {
                    if (txs[i]) {
                      serialized.push(txs[i].serialize_to_web(app));
                    }
                  }
                }
                mycallback(serialized);
              }, 'localhost');
              return _context19.a(2, 1);
            case 7:
              if (!(txmsg.request === 'stack post transaction')) {
                _context19.n = 11;
                break;
              }
              serializedTx = (_txmsg$data10 = txmsg.data) === null || _txmsg$data10 === void 0 ? void 0 : _txmsg$data10.transaction;
              if (serializedTx) {
                _context19.n = 8;
                break;
              }
              return _context19.a(2, 0);
            case 8:
              _context19.p = 8;
              // Deserialize and validate the transaction
              receivedTx = new Transaction();
              receivedTx.deserialize_from_web(app, serializedTx);

              // Basic validation - ensure it's a Stack post
              receivedMsg = receivedTx.returnMessage();
              if (!(receivedMsg.module !== 'Stack' || ((_receivedMsg$data = receivedMsg.data) === null || _receivedMsg$data === void 0 ? void 0 : _receivedMsg$data.type) !== 'stack_post')) {
                _context19.n = 9;
                break;
              }
              return _context19.a(2, 0);
            case 9:
              // Cache the received transaction
              sig = receivedTx.signature;
              if (sig) {
                this.transactionCache[sig] = receivedTx;
                console.debug("Stack: Cached post ".concat(sig, " received from peer"));
              }

              // Do NOT re-broadcast automatically
              // Do NOT render - this is middleware only
              return _context19.a(2, 1);
            case 10:
              _context19.p = 10;
              _t11 = _context19.v;
              // Invalid transaction - silently ignore (normal)
              console.debug("Stack: Failed to deserialize peer transaction", _t11);
              return _context19.a(2, 0);
            case 11:
              return _context19.a(2, _superPropGet(Stack, "handlePeerTransaction", this, 3)([app, tx, peer, mycallback]));
          }
        }, _callee19, this, [[8, 10]]);
      }));
      function handlePeerTransaction(_x15) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }() ////////////////////////////
    // NFT Access Resolution //
    ////////////////////////////
    /**
     * Resolves Stack NFT witness data from wallet for unlock-script construction.
     *
     * @param {string|null} authorPublicKey - Post author; when set, selects the Stack NFT
     *   whose creator matches this key
     * @returns {Object|null} Structured witness data with legacy `access_witness` JSON string, or null
     */
  }, {
    key: "resolveStackAccessData",
    value: function () {
      var _resolveStackAccessData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20() {
        var authorPublicKey,
          _nft$slip,
          _nft$slip2,
          _nft$slip3,
          _nft$slip4,
          _nft$slip5,
          nftList,
          stackCandidates,
          _iterator5,
          _step5,
          _rec$slip2,
          _rec,
          nftType,
          stackNFT,
          _iterator6,
          _step6,
          _rec$slip,
          rec,
          creator,
          SaitoNFT,
          nft,
          utxokey1,
          utxokey2,
          utxokey3,
          hops,
          duration,
          duration_sig,
          _nft$tx,
          _nft$tx$returnMessage,
          _nft_txmsg$data,
          _nft_txmsg$data2,
          nft_txmsg,
          access_witness_array,
          result,
          _args20 = arguments,
          _t12,
          _t13;
        return _regenerator().w(function (_context20) {
          while (1) switch (_context20.p = _context20.n) {
            case 0:
              authorPublicKey = _args20.length > 0 && _args20[0] !== undefined ? _args20[0] : null;
              _context20.p = 1;
              _context20.n = 2;
              return this.app.wallet.updateNFTList();
            case 2:
              nftList = this.app.options.wallet.nfts || [];
              if (!(!nftList || nftList.length === 0)) {
                _context20.n = 3;
                break;
              }
              return _context20.a(2, null);
            case 3:
              stackCandidates = [];
              _iterator5 = _createForOfIteratorHelper(nftList);
              try {
                for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                  _rec = _step5.value;
                  nftType = this.app.wallet.extractNFTType(((_rec$slip2 = _rec.slip3) === null || _rec$slip2 === void 0 ? void 0 : _rec$slip2.utxo_key) || '');
                  if (nftType === 'stack') {
                    stackCandidates.push(_rec);
                  }
                }
              } catch (err) {
                _iterator5.e(err);
              } finally {
                _iterator5.f();
              }
              if (!(stackCandidates.length === 0)) {
                _context20.n = 4;
                break;
              }
              return _context20.a(2, null);
            case 4:
              stackNFT = null;
              if (!authorPublicKey) {
                _context20.n = 13;
                break;
              }
              _iterator6 = _createForOfIteratorHelper(stackCandidates);
              _context20.p = 5;
              _iterator6.s();
            case 6:
              if ((_step6 = _iterator6.n()).done) {
                _context20.n = 8;
                break;
              }
              rec = _step6.value;
              creator = ((_rec$slip = rec.slip1) === null || _rec$slip === void 0 ? void 0 : _rec$slip.public_key) || '';
              if (!(creator === authorPublicKey)) {
                _context20.n = 7;
                break;
              }
              stackNFT = rec;
              return _context20.a(3, 8);
            case 7:
              _context20.n = 6;
              break;
            case 8:
              _context20.n = 10;
              break;
            case 9:
              _context20.p = 9;
              _t12 = _context20.v;
              _iterator6.e(_t12);
            case 10:
              _context20.p = 10;
              _iterator6.f();
              return _context20.f(10);
            case 11:
              if (stackNFT) {
                _context20.n = 12;
                break;
              }
              return _context20.a(2, null);
            case 12:
              _context20.n = 14;
              break;
            case 13:
              stackNFT = stackCandidates[0];
            case 14:
              // Create SaitoNFT object and load transaction to get full slip data
              SaitoNFT = require('../../lib/saito/ui/saito-nft/saito-nft');
              nft = new SaitoNFT(this.app, this, null, stackNFT, null);
              _context20.n = 15;
              return nft.fetchTransaction();
            case 15:
              utxokey1 = ((_nft$slip = nft.slip1) === null || _nft$slip === void 0 ? void 0 : _nft$slip.utxo_key) || '';
              utxokey2 = ((_nft$slip2 = nft.slip2) === null || _nft$slip2 === void 0 ? void 0 : _nft$slip2.utxo_key) || '';
              utxokey3 = ((_nft$slip3 = nft.slip3) === null || _nft$slip3 === void 0 ? void 0 : _nft$slip3.utxo_key) || '';
              if (!(!utxokey1 || !utxokey2 || !utxokey3)) {
                _context20.n = 16;
                break;
              }
              console.warn('Stack: NFT missing required slip utxo_keys');
              return _context20.a(2, null);
            case 16:
              hops = [];
              duration = null;
              duration_sig = null;
              try {
                nft_txmsg = (_nft$tx = nft.tx) === null || _nft$tx === void 0 || (_nft$tx$returnMessage = _nft$tx.returnMessage) === null || _nft$tx$returnMessage === void 0 ? void 0 : _nft$tx$returnMessage.call(_nft$tx);
                if (Array.isArray(nft_txmsg === null || nft_txmsg === void 0 || (_nft_txmsg$data = nft_txmsg.data) === null || _nft_txmsg$data === void 0 ? void 0 : _nft_txmsg$data.path)) {
                  hops = nft_txmsg.data.path;
                }
                if ((nft_txmsg === null || nft_txmsg === void 0 || (_nft_txmsg$data2 = nft_txmsg.data) === null || _nft_txmsg$data2 === void 0 ? void 0 : _nft_txmsg$data2.duration) != null) {
                  duration = nft_txmsg.data.duration;
                  duration_sig = nft_txmsg.data.duration_sig || null;
                }
              } catch (err) {
                // Absence of path/duration is normal for some NFT states
              }
              access_witness_array = [{
                utxokey1: utxokey1,
                utxokey2: utxokey2,
                utxokey3: utxokey3
              }];
              if (Array.isArray(hops) && hops.length > 0) {
                access_witness_array.push({
                  hops: hops
                });
              }
              if (duration != null) {
                access_witness_array.push({
                  duration: duration,
                  signature: duration_sig
                });
              }
              result = {
                utxokey1: utxokey1,
                utxokey2: utxokey2,
                utxokey3: utxokey3,
                hops: hops,
                duration: duration,
                duration_sig: duration_sig,
                nft_creator: nft.creator || ((_nft$slip4 = nft.slip1) === null || _nft$slip4 === void 0 ? void 0 : _nft$slip4.public_key) || '',
                nft_id: nft.id || '',
                access_witness: JSON.stringify(access_witness_array)
              };
              console.log('--------------------------------\nSTACK ACCESS WITNESS\n--------------------------------\n\n' + 'NFT ID:\n' + (result.nft_id || '') + '\n\n' + 'creator publickey:\n' + (result.nft_creator || '') + '\n\n' + 'owner publickey:\n' + (((_nft$slip5 = nft.slip2) === null || _nft$slip5 === void 0 ? void 0 : _nft$slip5.public_key) || '') + '\n\n' + 'access_witness:\n' + JSON.stringify(access_witness_array, null, 2) + '\n\n' + 'structured object:\n' + JSON.stringify(result, null, 2) + '\n\n--------------------------------');
              return _context20.a(2, result);
            case 17:
              _context20.p = 17;
              _t13 = _context20.v;
              console.warn('Stack: Error resolving NFT access data:', _t13);
              return _context20.a(2, null);
          }
        }, _callee20, this, [[5, 9, 10, 11], [1, 17]]);
      }));
      function resolveStackAccessData() {
        return _resolveStackAccessData.apply(this, arguments);
      }
      return resolveStackAccessData;
    }() ////////////////////////////
    // Transaction Loading   //
    ////////////////////////////
    /**
     * Loads a single transaction by signature.
     * Checks cache first, then queries peers, then falls back to archive.
     * Supports both callback and Promise/await usage.
     *
     * @param {string} signature - Transaction signature to load
     * @param {Object} options - Optional parameters. Can include `peer` (object or "localhost")
     * @param {Function} callback - Optional callback function(tx)
     * @returns {Transaction|null} Transaction object if no callback, null if not found
     */
  }, {
    key: "loadPost",
    value: function () {
      var _loadPost = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21(signature) {
        var _this10 = this;
        var options,
          callback,
          peer,
          access_script,
          access_hash,
          access_witness,
          accessData,
          cachedTx,
          localQuery,
          peerString,
          localTx,
          peers,
          peerKeys,
          _this$peers$firstPeer,
          firstPeerKey,
          peerObj,
          peerTx,
          _args21 = arguments,
          _t14;
        return _regenerator().w(function (_context21) {
          while (1) switch (_context21.p = _context21.n) {
            case 0:
              options = _args21.length > 1 && _args21[1] !== undefined ? _args21[1] : {};
              callback = _args21.length > 2 && _args21[2] !== undefined ? _args21[2] : null;
              // Extract peer from options if provided
              peer = (options === null || options === void 0 ? void 0 : options.peer) || null; // Build access context once per request
              access_script = null;
              access_hash = null;
              access_witness = null;
              _context21.n = 1;
              return this.resolveStackAccessData();
            case 1:
              accessData = _context21.v;
              if (accessData !== null && accessData !== void 0 && accessData.access_witness) {
                access_witness = accessData.access_witness;
              }

              // Validate signature
              if (!(!signature || typeof signature !== 'string')) {
                _context21.n = 3;
                break;
              }
              if (!callback) {
                _context21.n = 2;
                break;
              }
              callback(null);
              return _context21.a(2);
            case 2:
              return _context21.a(2, null);
            case 3:
              if (!this.transactionCache[signature]) {
                _context21.n = 5;
                break;
              }
              cachedTx = this.transactionCache[signature];
              if (!callback) {
                _context21.n = 4;
                break;
              }
              callback(cachedTx);
              return _context21.a(2);
            case 4:
              return _context21.a(2, cachedTx);
            case 5:
              // Step 3: Check localhost archive (if no peer specified)
              // This checks our own local archive before making network requests
              // For loadPost(), we don't know the author ahead of time, so we can't construct access_hash
              // Try loading without access first (works for public posts)
              localQuery = {
                field1: 'Stack',
                signature: signature,
                access_witness: access_witness
              }; // Step 2: If peer is provided, use it directly (skip localhost check and peer queries)
              if (!peer) {
                _context21.n = 6;
                break;
              }
              // Determine peer string for loadTransactions
              // Can be "localhost" string or a peer object (we'll use its identifier)
              peerString = peer;
              if (_typeof(peer) === 'object' && peer !== null) {
                // If it's a peer object, extract identifier (publicKey, address, or use object itself)
                // loadTransactions may accept the object directly, but we'll try to get a string identifier
                peerString = peer.publicKey || peer.address || peer;
              }
              return _context21.a(2, new Promise(function (resolve) {
                _this10.app.storage.loadTransactions(localQuery, function (txs) {
                  var tx = null;

                  // Find matching transaction
                  if (Array.isArray(txs) && txs.length > 0) {
                    tx = txs.find(function (t) {
                      return t.signature === signature;
                    });
                  }

                  // Cache if found
                  if (tx) {
                    _this10.transactionCache[signature] = tx;
                  }

                  // Handle callback or Promise
                  if (callback) {
                    callback(tx);
                    resolve(tx);
                  } else {
                    resolve(tx);
                  }
                }, peerString // Use provided peer (can be "localhost" or peer identifier)
                );
              }));
            case 6:
              _context21.n = 7;
              return new Promise(function (resolve) {
                _this10.app.storage.loadTransactions(localQuery, function (txs) {
                  var tx = null;

                  // Find matching transaction
                  if (Array.isArray(txs) && txs.length > 0) {
                    tx = txs.find(function (t) {
                      return t.signature === signature;
                    });
                  }

                  // Cache if found
                  if (tx) {
                    _this10.transactionCache[signature] = tx;
                  }
                  resolve(tx);
                }, 'localhost' // Specify localhost as peer to check local archive
                );
              });
            case 7:
              localTx = _context21.v;
              if (!localTx) {
                _context21.n = 9;
                break;
              }
              if (!callback) {
                _context21.n = 8;
                break;
              }
              callback(localTx);
              return _context21.a(2);
            case 8:
              return _context21.a(2, localTx);
            case 9:
              _context21.n = 10;
              return this.app.network.getPeers();
            case 10:
              peers = _context21.v;
              if (!(peers.length === 0)) {
                _context21.n = 11;
                break;
              }
              this.pending_post_sig = signature;
              this.pending_post_pk = null;
              return _context21.a(2, null);
            case 11:
              peerKeys = Object.keys(this.peers);
              if (!(peerKeys.length > 0)) {
                _context21.n = 17;
                break;
              }
              firstPeerKey = peerKeys[0];
              peerObj = (_this$peers$firstPeer = this.peers[firstPeerKey]) === null || _this$peers$firstPeer === void 0 ? void 0 : _this$peers$firstPeer.peer;
              if (!(peerObj && peerObj.publicKey !== undefined)) {
                _context21.n = 17;
                break;
              }
              _context21.p = 12;
              _context21.n = 13;
              return new Promise(function (resolve) {
                // Query peer for the post
                _this10.app.network.sendRequestAsTransaction('load stack post', {
                  signature: signature,
                  access_witness: access_witness
                }, function (response) {
                  // Response is array of serialized transactions
                  if (Array.isArray(response) && response.length > 0) {
                    try {
                      var tx = new Transaction();
                      tx.deserialize_from_web(_this10.app, response[0]);

                      // Validate it's the transaction we requested
                      if (tx.signature === signature) {
                        // Cache it
                        _this10.transactionCache[signature] = tx;
                        resolve(tx);
                        return;
                      }
                    } catch (error) {
                      console.debug("Stack.loadPost: Failed to deserialize peer response", error);
                    }
                  }
                  // Peer didn't have it or returned invalid data - resolve null
                  resolve(null);
                }, peerObj.publicKey);
              });
            case 13:
              peerTx = _context21.v;
              if (!peerTx) {
                _context21.n = 15;
                break;
              }
              if (!callback) {
                _context21.n = 14;
                break;
              }
              callback(peerTx);
              return _context21.a(2);
            case 14:
              return _context21.a(2, peerTx);
            case 15:
              _context21.n = 17;
              break;
            case 16:
              _context21.p = 16;
              _t14 = _context21.v;
              // Peer query failed - silently return null (normal)
              console.debug("Stack.loadPost: Peer query failed", _t14);
            case 17:
              if (!callback) {
                _context21.n = 18;
                break;
              }
              callback(null);
              return _context21.a(2);
            case 18:
              return _context21.a(2, null);
          }
        }, _callee21, this, [[12, 16]]);
      }));
      function loadPost(_x16) {
        return _loadPost.apply(this, arguments);
      }
      return loadPost;
    }()
    /**
     * Loads posts for a specific author from local and optionally remote archives.
     *
     * @param {string} publicKey - The author's public key
     * @param {Object} options - Options object
     * @param {boolean} options.forceRemote - If true, also query remote peers (default: true)
     * @returns {Promise<Array<Transaction>>} Array of Transaction objects, deduplicated by signature
     */
  }, {
    key: "loadPostsForAuthor",
    value: function () {
      var _loadPostsForAuthor = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22(publicKey) {
        var options,
          _yield$this$fetchPost,
          posts,
          _args22 = arguments;
        return _regenerator().w(function (_context22) {
          while (1) switch (_context22.n) {
            case 0:
              options = _args22.length > 1 && _args22[1] !== undefined ? _args22[1] : {};
              _context22.n = 1;
              return this.fetchPostsForAuthor(publicKey, options);
            case 1:
              _yield$this$fetchPost = _context22.v;
              posts = _yield$this$fetchPost.posts;
              return _context22.a(2, posts);
          }
        }, _callee22, this);
      }));
      function loadPostsForAuthor(_x17) {
        return _loadPostsForAuthor.apply(this, arguments);
      }
      return loadPostsForAuthor;
    }()
    /**
     * Same as loadPostsForAuthor, but also reports whether the result is complete.
     * `complete` is false only when a remote query was requested but skipped because
     * no peers were connected yet — callers should not treat that result as final.
     *
     * @returns {Promise<{posts: Array<Transaction>, complete: boolean}>}
     */
  }, {
    key: "fetchPostsForAuthor",
    value: function () {
      var _fetchPostsForAuthor = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23(publicKey) {
        var _this11 = this;
        var _ref3,
          _ref3$forceRemote,
          forceRemote,
          seenSignatures,
          posts,
          access_witness,
          accessData,
          _require2,
          _getAccessScriptForIntent,
          publishIntent,
          localQuery,
          requestTx,
          walletPublicKey,
          localPosts,
          _iterator7,
          _step7,
          _tx4,
          peers,
          remotePosts,
          peerKeys,
          _this$peers$firstPeer2,
          firstPeerKey,
          peerObj,
          remoteQuery,
          _iterator8,
          _step8,
          tx,
          postGroups,
          _i,
          _posts,
          _tx3,
          logicalPostId,
          existingTx,
          existingTime,
          currentTime,
          collapsedPosts,
          _args23 = arguments;
        return _regenerator().w(function (_context23) {
          while (1) switch (_context23.n) {
            case 0:
              _ref3 = _args23.length > 1 && _args23[1] !== undefined ? _args23[1] : {}, _ref3$forceRemote = _ref3.forceRemote, forceRemote = _ref3$forceRemote === void 0 ? true : _ref3$forceRemote;
              if (!(!publicKey || !this.app.crypto.isPublicKey(publicKey))) {
                _context23.n = 1;
                break;
              }
              return _context23.a(2, {
                posts: [],
                complete: true
              });
            case 1:
              seenSignatures = new Set();
              posts = [];
              access_witness = null; // PART 1: Resolve Stack NFT access data (mirrors Vault pattern)
              // This provides witness data that can be attached to Archive queries
              _context23.n = 2;
              return this.resolveStackAccessData(publicKey);
            case 2:
              accessData = _context23.v;
              if (accessData !== null && accessData !== void 0 && accessData.access_witness) {
                access_witness = accessData.access_witness;
              }
              if (accessData && accessData.access_witness) {
                // Construct the access script for this author (transferable private posts)
                // This matches the script used when creating private posts
                _require2 = require('./lib/access/access-scripts'), _getAccessScriptForIntent = _require2.getAccessScriptForIntent;
                publishIntent = {
                  visibility: 'private',
                  access_mode: 'transferable',
                  time_limit: null,
                  author: publicKey
                };
              }

              // PART 2.1: Query local archive first
              // Build query object - attach access data if NFT exists
              localQuery = {
                field1: 'Stack',
                field2: publicKey,
                field4: 'stack:post'
              };
              if (access_witness) {
                localQuery.access_witness = access_witness;
              }

              // Private path: one signed proving Transaction for local request_tx and remote peer send
              requestTx = null;
              if (!access_witness) {
                _context23.n = 6;
                break;
              }
              _context23.n = 3;
              return this.app.wallet.getPublicKey();
            case 3:
              walletPublicKey = _context23.v;
              _context23.n = 4;
              return this.app.wallet.createUnsignedTransaction(walletPublicKey, BigInt(0), BigInt(0));
            case 4:
              requestTx = _context23.v;
              requestTx.msg = {
                request: 'load stack posts for author',
                data: {
                  field1: 'Stack',
                  field2: publicKey,
                  field4: 'stack:post',
                  access_witness: access_witness
                }
              };
              _context23.n = 5;
              return requestTx.sign();
            case 5:
              localQuery.request_tx = requestTx;
            case 6:
              _context23.n = 7;
              return new Promise(function (resolve) {
                _this11.app.storage.loadTransactions(localQuery, function (txs) {
                  resolve(txs || []);
                }, 'localhost');
              });
            case 7:
              localPosts = _context23.v;
              // PART 2.2: Collect and deduplicate local results
              _iterator7 = _createForOfIteratorHelper(localPosts);
              try {
                for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                  _tx4 = _step7.value;
                  if (_tx4 && _tx4.signature && !seenSignatures.has(_tx4.signature)) {
                    seenSignatures.add(_tx4.signature);
                    posts.push(_tx4);
                  }
                }

                // PART 2.3: If forceRemote, query remote peers
              } catch (err) {
                _iterator7.e(err);
              } finally {
                _iterator7.f();
              }
              if (!forceRemote) {
                _context23.n = 15;
                break;
              }
              _context23.n = 8;
              return this.app.network.getPeers();
            case 8:
              peers = _context23.v;
              if (!(peers.length === 0)) {
                _context23.n = 9;
                break;
              }
              return _context23.a(2, {
                posts: posts,
                complete: false
              });
            case 9:
              remotePosts = [];
              if (!(access_witness && requestTx)) {
                _context23.n = 12;
                break;
              }
              // Private path: send the same signed Transaction to a Stack peer
              peerKeys = Object.keys(this.peers);
              if (!(peerKeys.length > 0)) {
                _context23.n = 11;
                break;
              }
              firstPeerKey = peerKeys[0];
              peerObj = (_this$peers$firstPeer2 = this.peers[firstPeerKey]) === null || _this$peers$firstPeer2 === void 0 ? void 0 : _this$peers$firstPeer2.peer;
              if (!(peerObj && peerObj.publicKey !== undefined)) {
                _context23.n = 11;
                break;
              }
              _context23.n = 10;
              return new Promise(function (resolve) {
                _this11.app.network.sendTransactionWithCallback(requestTx, function (responseTx) {
                  var response = responseTx === null || responseTx === void 0 ? void 0 : responseTx.msg;
                  var txs = [];
                  if (Array.isArray(response)) {
                    for (var i = 0; i < response.length; i++) {
                      try {
                        var remoteTx = new Transaction();
                        remoteTx.deserialize_from_web(_this11.app, response[i]);
                        txs.push(remoteTx);
                      } catch (error) {
                        console.debug('Stack.loadPostsForAuthor: Failed to deserialize peer response', error);
                      }
                    }
                  }
                  resolve(txs);
                }, peerObj.publicKey);
              });
            case 10:
              remotePosts = _context23.v;
            case 11:
              _context23.n = 14;
              break;
            case 12:
              // Public path: unchanged Archive remote query
              remoteQuery = {
                field1: 'Stack',
                field2: publicKey,
                field4: 'stack:post'
              };
              _context23.n = 13;
              return new Promise(function (resolve) {
                _this11.app.storage.loadTransactions(remoteQuery, function (txs) {
                  resolve(txs || []);
                }, null // null = remote peers
                );
              });
            case 13:
              remotePosts = _context23.v;
            case 14:
              _iterator8 = _createForOfIteratorHelper(remotePosts);
              try {
                for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                  tx = _step8.value;
                  seenSignatures.add(tx.signature);
                  posts.push(tx);
                }

                // PART 2.4: For each remotely discovered post, append if unseen and save to localhost
                /***
                for (const tx of remotePosts) {
                  if (tx && tx.signature && !seenSignatures.has(tx.signature)) {
                    seenSignatures.add(tx.signature);
                    posts.push(tx);
                     // PART 2.5: Immediately save to localhost archive with proper revision handling
                    try {
                      const txmsg = tx.returnMessage();
                      const parent_id = txmsg?.data?.parent_id || null;
                      const from = tx?.from[0]?.publicKey;
                      
                      // For revisions: delete older revisions with same (author, parent_id)
                      if (parent_id && from) {
                        const olderRevisions = await new Promise((resolve) => {
                          this.app.storage.loadTransactions(
                            {
                              field1: 'Stack',
                              field2: from,
                              field4: 'stack:post',
                              field5: parent_id
                            },
                            (txs) => {
                              resolve(txs || []);
                            },
                            'localhost'
                          );
                        });
                        
                        // Delete all older revisions
                        for (const oldTx of olderRevisions) {
                          if (oldTx.signature !== tx.signature) {
                            try {
                              await this.app.storage.deleteTransaction(oldTx, null, 'localhost');
                            } catch (error) {
                              console.warn('Stack: Error deleting older revision when saving remote post:', error);
                            }
                          }
                        }
                      }
                      
                      // Save with field5 = parent_id (or empty for root posts)
                      await this.app.storage.saveTransaction(
                        tx,
                        { 
                          field4: 'stack:post', 
                          field5: parent_id || '',
                          preserve: 1 
                        },
                        'localhost'
                      );
                    } catch (error) {
                      console.warn('Stack: Failed to save remote post to local archive:', error);
                    }
                  }
                }
                ***/
              } catch (err) {
                _iterator8.e(err);
              } finally {
                _iterator8.f();
              }
            case 15:
              // ========================================================================
              // COLLAPSE REVISIONS: Group by logical post identity, keep latest only
              // ========================================================================
              // A "post" is a LOGICAL OBJECT WITH REVISIONS, not a single transaction.
              // We MUST show only ONE entry per logical post (the latest revision).
              // This handles:
              // - Race conditions during archive deletion
              // - Remote peers returning stale data
              // - Partial deletions
              // - Reorgs
              postGroups = new Map(); // key: logicalPostId, value: Transaction
              for (_i = 0, _posts = posts; _i < _posts.length; _i++) {
                _tx3 = _posts[_i];
                try {
                  // Use canonical helper to compute logical post identity
                  logicalPostId = this.getLogicalPostId(_tx3); // Get current best revision for this logical post
                  existingTx = postGroups.get(logicalPostId);
                  if (!existingTx) {
                    // First occurrence of this logical post
                    postGroups.set(logicalPostId, _tx3);
                  } else {
                    // Compare timestamps - keep the newer one
                    existingTime = existingTx.timestamp || 0;
                    currentTime = _tx3.timestamp || 0;
                    if (currentTime > existingTime) {
                      postGroups.set(logicalPostId, _tx3);
                    }
                  }
                } catch (error) {
                  // Skip malformed transactions, but log for debugging
                  console.warn('Stack: Error processing transaction in loadPostsForAuthor:', error);
                }
              }

              // Create new array with collapsed versions (one per logical post)
              // Do NOT reassign posts (it is const) - create new variable instead
              collapsedPosts = Array.from(postGroups.values()); // Sort by timestamp DESC (most recent first)
              collapsedPosts.sort(function (a, b) {
                var aTime = a.timestamp || 0;
                var bTime = b.timestamp || 0;
                return bTime - aTime;
              });
              this.postsCache.byAuthor.set(publicKey, collapsedPosts);
              return _context23.a(2, {
                posts: collapsedPosts,
                complete: true
              });
          }
        }, _callee23, this);
      }));
      function fetchPostsForAuthor(_x18) {
        return _fetchPostsForAuthor.apply(this, arguments);
      }
      return fetchPostsForAuthor;
    }()
    /**
     * Loads multiple transactions by their signatures.
     * Iterates through keys starting at index, preserving order.
     * Skips null results (missing transactions are normal).
     * Supports both callback and Promise/await usage.
     *
     * @param {Array<string>} keys - Array of transaction signatures
     * @param {number} index - Starting index in keys array (default: 0)
     * @param {Object} options - Optional parameters (reserved for future use)
     * @param {Function} callback - Optional callback function(array)
     * @returns {Array<Transaction>} Array of Transaction objects (no nulls)
     */
  }, {
    key: "loadPosts",
    value: function () {
      var _loadPosts = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24(keys) {
        var index,
          options,
          callback,
          results,
          signaturesToLoad,
          _iterator9,
          _step9,
          signature,
          tx,
          _args24 = arguments,
          _t15,
          _t16;
        return _regenerator().w(function (_context24) {
          while (1) switch (_context24.p = _context24.n) {
            case 0:
              index = _args24.length > 1 && _args24[1] !== undefined ? _args24[1] : 0;
              options = _args24.length > 2 && _args24[2] !== undefined ? _args24[2] : {};
              callback = _args24.length > 3 && _args24[3] !== undefined ? _args24[3] : null;
              if (!(!Array.isArray(keys) || keys.length === 0)) {
                _context24.n = 2;
                break;
              }
              if (!callback) {
                _context24.n = 1;
                break;
              }
              callback([]);
              return _context24.a(2);
            case 1:
              return _context24.a(2, []);
            case 2:
              // Ensure index is valid
              if (index < 0) index = 0;
              if (!(index >= keys.length)) {
                _context24.n = 4;
                break;
              }
              if (!callback) {
                _context24.n = 3;
                break;
              }
              callback([]);
              return _context24.a(2);
            case 3:
              return _context24.a(2, []);
            case 4:
              // Collect results, preserving order
              results = [];
              signaturesToLoad = keys.slice(index); // Load each transaction sequentially to preserve order
              _iterator9 = _createForOfIteratorHelper(signaturesToLoad);
              _context24.p = 5;
              _iterator9.s();
            case 6:
              if ((_step9 = _iterator9.n()).done) {
                _context24.n = 11;
                break;
              }
              signature = _step9.value;
              _context24.p = 7;
              _context24.n = 8;
              return this.loadPost(signature, options);
            case 8:
              tx = _context24.v;
              if (tx) {
                results.push(tx);
              }
              // Skip nulls silently - missing transactions are normal
              _context24.n = 10;
              break;
            case 9:
              _context24.p = 9;
              _t15 = _context24.v;
              // Silently skip errors - permission failures are normal
              console.debug("Stack.loadPosts: Failed to load ".concat(signature), _t15);
            case 10:
              _context24.n = 6;
              break;
            case 11:
              _context24.n = 13;
              break;
            case 12:
              _context24.p = 12;
              _t16 = _context24.v;
              _iterator9.e(_t16);
            case 13:
              _context24.p = 13;
              _iterator9.f();
              return _context24.f(13);
            case 14:
              if (!callback) {
                _context24.n = 15;
                break;
              }
              callback(results);
              return _context24.a(2, results);
            case 15:
              return _context24.a(2, results);
          }
        }, _callee24, this, [[7, 9], [5, 12, 13, 14]]);
      }));
      function loadPosts(_x19) {
        return _loadPosts.apply(this, arguments);
      }
      return loadPosts;
    }() ////////////////////////////
    // Web Server            //
    ////////////////////////////
    ///////////////
    // webserver //
    ///////////////
  }, {
    key: "webServer",
    value: function webServer(app, expressapp, express) {
      var alternative_slug = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var webdir = "".concat(__dirname, "/../../mods/").concat(this.dirname, "/web");
      var uri = alternative_slug || '/' + encodeURI(this.returnSlug());
      var stack_self = this;

      //
      // 1. STATIC FILES — ALWAYS FIRST
      //
      // This ensures /stack/js, /stack/css, etc. resolve correctly
      //
      expressapp.use(uri, express["static"](webdir));

      //
      // 2. STACK APP BOOTSTRAP
      //
      //   /stack
      //   /stack/<publickey>
      //   /stack/<publickey>/<txsig>
      //
      // Article GET loads the transaction via loadPost() so OG tags in the
      // initial HTML do not depend on JavaScript or transactionCache.
      // The browser still hydrates the page from saito.js / __STACK_INITIAL_POST.
      //
      expressapp.get("".concat(uri), /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee25(req, res) {
          var _req$query;
          var _tx$returnMessage, tx, image, dataUri, base64Data, img, mime, _t17;
          return _regenerator().w(function (_context25) {
            while (1) switch (_context25.p = _context25.n) {
              case 0:
                if (!(req !== null && req !== void 0 && (_req$query = req.query) !== null && _req$query !== void 0 && _req$query.og_img_sig)) {
                  _context25.n = 7;
                  break;
                }
                _context25.p = 1;
                _context25.n = 2;
                return stack_self.loadPost(req.query.og_img_sig, {
                  peer: 'localhost'
                });
              case 2:
                tx = _context25.v;
                image = tx === null || tx === void 0 || (_tx$returnMessage = tx.returnMessage()) === null || _tx$returnMessage === void 0 || (_tx$returnMessage = _tx$returnMessage.data) === null || _tx$returnMessage === void 0 ? void 0 : _tx$returnMessage.image;
                if (!(typeof image !== 'string' || !image)) {
                  _context25.n = 3;
                  break;
                }
                return _context25.a(2, res.status(404).end());
              case 3:
                // The editor stores raw base64; older posts may include a data URI.
                dataUri = image.match(/^data:(image\/(?:png|jpeg|jpg|gif|webp|avif));base64,([^]+)$/i);
                base64Data = dataUri ? dataUri[2] : image;
                if (/^[a-z\d+/\s]+={0,2}$/i.test(base64Data)) {
                  _context25.n = 4;
                  break;
                }
                return _context25.a(2, res.status(404).end());
              case 4:
                img = Buffer.from(base64Data, 'base64');
                if (img.length) {
                  _context25.n = 5;
                  break;
                }
                return _context25.a(2, res.status(404).end());
              case 5:
                // resizeImg produces JPEG, while unresized uploads may retain their format.
                mime = 'image/png';
                if (img.subarray(0, 3).equals(Buffer.from([0xff, 0xd8, 0xff]))) {
                  mime = 'image/jpeg';
                } else if (img.toString('ascii', 0, 3) === 'GIF') {
                  mime = 'image/gif';
                } else if (img.toString('ascii', 0, 4) === 'RIFF' && img.toString('ascii', 8, 12) === 'WEBP') {
                  mime = 'image/webp';
                }
                res.writeHead(200, {
                  'Content-Type': dataUri ? dataUri[1].toLowerCase().replace('image/jpg', 'image/jpeg') : mime,
                  'Content-Length': img.length
                });
                return _context25.a(2, res.end(img));
              case 6:
                _context25.p = 6;
                _t17 = _context25.v;
                console.debug('Stack: Failed to load post image', _t17);
                return _context25.a(2, res.status(404).end());
              case 7:
                res.setHeader('Content-type', 'text/html');
                res.charset = 'UTF-8';
                return _context25.a(2, res.send(HomePage(app, stack_self, app.build_number, Object.assign({}, stack_self.social))));
            }
          }, _callee25, null, [[1, 6]]);
        }));
        return function (_x20, _x21) {
          return _ref4.apply(this, arguments);
        };
      }());
      expressapp.get("".concat(uri, "/:publickey"), function (req, res) {
        res.setHeader('Content-type', 'text/html');
        res.charset = 'UTF-8';
        var updateSocial = Object.assign({}, stack_self.social);
        updateSocial.description = "Follow ".concat(app.keychain.returnUsername(req.params.publickey));
        return res.send(HomePage(app, stack_self, app.build_number, updateSocial));
      });
      expressapp.get("".concat(uri, "/:publickey/:txsig"), /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee26(req, res) {
          var publickey, txsig, updateSocial, articleTx, _txmsg$data11, _txmsg$data12, _txmsg$data13, _articleTx$from, txmsg, author, identifier, _t18;
          return _regenerator().w(function (_context26) {
            while (1) switch (_context26.n) {
              case 0:
                res.setHeader('Content-type', 'text/html');
                res.charset = 'UTF-8';
                publickey = req.params.publickey;
                txsig = req.params.txsig;
                updateSocial = Object.assign({}, stack_self.social);
                updateSocial.url = stack_self.resolveSocialUrl("".concat(uri, "/").concat(publickey, "/").concat(txsig));
                if (!txsig) {
                  _context26.n = 2;
                  break;
                }
                _context26.n = 1;
                return stack_self.loadPost(txsig, {
                  peer: 'localhost'
                });
              case 1:
                _t18 = _context26.v;
                _context26.n = 3;
                break;
              case 2:
                _t18 = null;
              case 3:
                articleTx = _t18;
                if (articleTx) {
                  try {
                    txmsg = articleTx.returnMessage();
                    if (txmsg !== null && txmsg !== void 0 && (_txmsg$data11 = txmsg.data) !== null && _txmsg$data11 !== void 0 && _txmsg$data11.title) {
                      updateSocial.title = txmsg.data.title;
                    }
                    if (txmsg !== null && txmsg !== void 0 && (_txmsg$data12 = txmsg.data) !== null && _txmsg$data12 !== void 0 && _txmsg$data12.imageUrl) {
                      updateSocial.image = stack_self.resolveSocialUrl(txmsg.data.imageUrl);
                    } else if (txmsg !== null && txmsg !== void 0 && (_txmsg$data13 = txmsg.data) !== null && _txmsg$data13 !== void 0 && _txmsg$data13.image) {
                      updateSocial.image = stack_self.resolveSocialUrl("".concat(uri, "?og_img_sig=").concat(encodeURIComponent(txsig)));
                    }
                    author = ((_articleTx$from = articleTx.from) === null || _articleTx$from === void 0 || (_articleTx$from = _articleTx$from[0]) === null || _articleTx$from === void 0 ? void 0 : _articleTx$from.publicKey) || publickey;
                    identifier = app.keychain.returnIdentifierByPublicKey(author, true) || author;
                    updateSocial.description = "".concat(identifier, " posted on Saito Stack.");
                  } catch (err) {
                    console.debug('Stack: Failed to serialize cached post for initial HTML', err);
                  }
                }
                return _context26.a(2, res.send(HomePage(app, stack_self, app.build_number, updateSocial, articleTx ? articleTx.serialize_to_web(app) : null)));
            }
          }, _callee26);
        }));
        return function (_x22, _x23) {
          return _ref5.apply(this, arguments);
        };
      }());
    }
  }]);
}(ModTemplate);
module.exports = Stack;